import React, {useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment-timezone';
import 'moment/locale/es';
import { quickTip_en,quickTip_es } from '../components/results/quickTips';
import { capitalize, cloneDeep } from 'lodash';
import LZString from 'lz-string';
import { retrieveFileData, retrieveJsonData } from './common';

const HOURS_TO_SHOW_BLUE = 48;
const HOURS_TO_SHOW_STARTS_SOON = 24;
const MIN_TO_SHOW_IN_PROGRESS = 15;
const BLUE_COLOR = "#006FC1";
const DEFAULT_COLOR = "#716F6D";
const ORANGE_COLOR = "#FF8027";
const DARK_ORANGE_COLOR = "#B95319";
const SEATS_THRESHHOLD = 3;
const GREEN_COLOR = '#008330';
const BROWN_COLOR = '#732706';
let dateFormat = "MMM D, h:mm a";
const TAG_BILINGUAL="Bilingual";
const TAG_SPANISH="En español";
const TAG_JUST_ADDED="Just added";
const TAG_RECORDED_EVENTS="Recorded Event";

const GET_STARTED = 'Get Started';
const STD_COURSE = 'Standard Course';
const MINI_COURSE = 'Mini Course';
const WARN_ICON = 'warning';
const HIS_ICON = 'history';
const COMPLETED_ICON = 'checkmark-alternate';
const EVENT_FULL_TEXT = 'Event full';
const EVENT_FULL_JOIN_WAITLIST_TEXT = 'Event full - join waitlist';
const EVENT_FULL_WAITLIST_AVAILABLE_TEXT = 'Event full - waitlist available';
const FINAL_DAY_REGISTER = 'Final day to register';
const LAST_DAY_TO_ENROLL = 'Last day to enroll'
const REGISTRATION_CLOSED = 'Registration closed';
const SPOTS_REMAINING = 'spots remaining';
const STATUS_ENDED = "Ended";
const STATUS_START_SOON = "Starts soon";
const SEATS_LEFT_TEXT = 'seats left';
const ONE_SEATS_LEFT_TEXT = 'seat left';
const ASK_THE_EXPERT = 'Ask the Expert';
const Hands_ON_HELP = 'Hands-on Help';
const COURSES_QA = 'Courses Q&As';
const NETWORKING_SESSIONS = 'Networking Sessions';

let topicsCollection = [
  { id: '2', arialabel: 'New', label: 'Branding', icon: 'small-business' },
  { id: '1', arialabel: 'Recommended', label: 'Cybersecurity', icon: 'security-check' },
  { id: '3', arialabel: 'Recommended', label: 'Funding', icon: 'coin' },
  { id: '4', arialabel: 'Recommended', label: 'Legal Essentials', icon: 'law' },
  { id: '5', arialabel: 'Recommended', label: 'Managing Money', icon: 'wallet' },
  { id: '6', arialabel: 'Recommended', label: 'Online Marketing', icon: 'laptop-trends' },
  { id: '7', arialabel: 'Recommended', label: 'Operations', icon: 'operational-transformation' },
  { id: '8', arialabel: 'Recommended', label: 'Social Media', icon: 'chat' },
  { id: '9', arialabel: 'Recommended', label: 'Strategy', icon: 'survey' },
  { id: '10', arialabel: 'Recommended', label: 'Website Design', icon: 'digital-content' },
  { id: '11', arialabel: 'Recommended', label: 'Wellness', icon: 'emoji' },
  { id: '12', arialabel: 'Recommended', label: 'Winning Customers', icon: 'custom-audience' },
];

Date.prototype.addDays = function(days)
{
    var day = new Date(this.valueOf());
    day.setDate(day.getDate() + days);
    return day;
}

function compareCurrentTimeInSeconds(date) {
    const now = new Date(Date.now());
    const elapsedTimeInSeconds = Math.floor((now - date) / 1000);
    return elapsedTimeInSeconds;
}

function getCookieValue(name){
    return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';
}

function setWithExpiry(key, value, ttl, expiryTime) {
	const now = new Date()

	// `item` is an object which contains the original value
	// as well as the time when it's supposed to expire
	const item = {
		value: value,
		expiry: expiryTime && new Date().getTime() < expiryTime ? expiryTime : now.getTime() + ttl,
	}
	localStorage.setItem(key, JSON.stringify(item))
}

function getWithExpiry(key) {
	const itemStr = localStorage.getItem(key)
	// if the item doesn't exist, return null
	if (!itemStr) {
		return null
	}
	const item = JSON.parse(itemStr)
	const now = new Date()
	// compare the expiry time of the item with the current time
	if (now.getTime() > item.expiry) {
		// If the item is expired, delete the item from storage
		// and return null
		localStorage.removeItem(key)
		return null
	}
	return item.value
}

const createCourseObject = (course, userLanguage) => {
  let userLanguageTitle = course.localizeData.filter(e => e.locale.indexOf(userLanguage) != -1);
  let title = course.title;
  if(userLanguageTitle.length > 0) {
    console.log("userLanguageTitle", userLanguageTitle);
    title = userLanguageTitle[0].name
  }
  let type = '';
  if(course.tags?.indexOf('Standard Course') != -1) {
    type = STD_COURSE;
  } else if (course.tags?.indexOf('Mini Course') != -1) {
    type = MINI_COURSE
  }
  
  let icon = 'timer';

  let skillLevel = [];
  course.skills?.forEach((skill) => {
    if(skill.level && skill.level != null) {
      skillLevel.push(skill.name +':'+skill.level);
    }
  });

  const dateTimeStap = course.datePublished;
  const currentDate = new Date();
  const dateDiff = (currentDate - new Date(dateTimeStap)) / (1000 * 60 * 60 * 24);

    let tag="";
    if (course.locale.indexOf('es-ES') != -1 &&  userLanguage === "es" ){
      tag= TAG_SPANISH;
    }else if (dateDiff <= 30){
      tag= TAG_JUST_ADDED;
    }

  return {
    id: course.id,
    image: course.imageUrl, 
    title: title,
    format: 'Course',
    tag:tag,
    locale: course.locale,
    enrollmentCount: course.enrollmentCount,
    tags:course.tags,
    launchUrl: course.launchUrl,
    type: type,
    duration: `${Math.ceil(course.duration/60)} minutes`,
    icon: icon,
    datePublished: course.datePublished,
    skillLevels: skillLevel
  };
}

const forcedRankingOffersTopics = (offersData,topics,requiredResults) => {
  const forcedRanking = offersData?.forcedRanking;
  const rawOffers = offersData?.offers;
  var interestsTopics=Object.keys(forcedRanking ?? {});
  let userInterests = [];
  // const businessData = userDataFromStore?.business;
  interestsTopics.map((item) => {
    if (topics.includes(item)) {
      userInterests.push(topics[0]);
    }
  });
  let sortedresults = [];
  let interestIndex = 0, forcedRankIndex = 0, completedIndex = 0;
  if(userInterests?.length == 1 && userInterests[0] == "I'm not sure"){
    completedIndex++;
  }
  while (completedIndex < userInterests?.length) {
    const tempObj = forcedRanking?.[userInterests[interestIndex]];
    if (tempObj?.length > forcedRankIndex) {
      var offerObject = rawOffers?.filter(e => e.id == tempObj[forcedRankIndex])?.[0];
      if (offerObject && sortedresults?.filter((item) => item == offerObject)?.length == 0) {
        sortedresults.push(offerObject);
      }
    } else {
      completedIndex++;
    }
    if (interestIndex < (userInterests?.length - 1)) {
      interestIndex++;
    }
    else {
      interestIndex = 0;
      forcedRankIndex++;
    }
  }
  var otherIndex = 0;
  const iamNotSureRankinList = forcedRanking?.["I'm not sure"];
  while (sortedresults?.length < requiredResults && otherIndex < iamNotSureRankinList?.length) {
    var otherSortItem = rawOffers?.filter(e => e.id == iamNotSureRankinList[otherIndex])?.[0];
    if (otherSortItem && sortedresults?.filter((item) => item == otherSortItem)?.length == 0) {
      sortedresults.push(otherSortItem);
    }
    otherIndex++;
  }
  const filteredResults = sortedresults?.filter((res) => res?.isGrants !== "true")
  return filteredResults;
}

const createLearningPathObject = (learningPath, userLanguage) => {
  let userLanguageTitle = learningPath?.localizeData?.filter(e => e.locale.indexOf(userLanguage) != -1);
  let title = "";
  let shortDesc = "";
  if(userLanguageTitle?.length > 0) {
    console.log("userLanguageTitle", userLanguageTitle);
    title = userLanguageTitle[0].name;
    shortDesc = userLanguageTitle[0].description;
  } else {
    title = learningPath.localizeData[0].name;
    shortDesc = learningPath.localizeData[0].description;
  }

  let type = 'Topic';
  if(learningPath.tags?.indexOf('Standard Course') != -1) {
    type = STD_COURSE;
  } else if (learningPath.tags?.indexOf('Mini Course') != -1) {
    type = MINI_COURSE;
  }
  
  let status = GET_STARTED;
  let statusColor = DEFAULT_COLOR;
  let statusIcon = 'timer';

  let numberOfResources = 0;
  // learningPath.listOfResources.forEach((item) => {
  //   numberOfResources = numberOfResources + item.loIds.length;
  // });

  const dateTimeLearningStap = learningPath.datePublished;
  const currentDate = new Date();
  const dateDiff = (currentDate - new Date(dateTimeLearningStap)) / (1000 * 60 * 60 * 24);

  let tag="";
  if (learningPath.locale.indexOf('es-ES') != -1 &&  userLanguage === "es" ){
    tag= TAG_SPANISH;
  }else if (dateDiff <= 30){
    tag= TAG_JUST_ADDED;
  }

  return {
    courseId: learningPath.id,
    desktopImage: learningPath.imageUrl, 
    label: title,
    format: 'Learning Path',
    tag:tag,
    locale: learningPath.locale,
    enrollmentCount: learningPath.enrollmentCount,
    tags:learningPath.tags,
    type: type,
    duration: learningPath.duration,
    datePublished: learningPath.datePublished,
    //resourceType: topicsCollection.filter(e => learningPath.tags?.indexOf(e.label) != -1).map(e=>e.label).join(', '),
    shortDesc: shortDesc,
    duration: { 
      time: status, 
      color: statusColor, 
      icon: statusIcon
    },
    instances: learningPath.instances.map(instance => ({
      id: instance.id,
      type: instance.type
    }))
  };
}

const createEventObject = (event, userLanguage) => {
  let locationForConferenceModule = event?.modules?.filter(e => e.location != null);
  let locationForConf = null;
  if(locationForConferenceModule?.length > 0) 
    locationForConf = locationForConferenceModule[0]?.location;

  //Change locale for date format
  console.log("userLanguage", userLanguage);
  moment.locale(userLanguage);
  switch(userLanguage) {
    case "en":
      dateFormat = "MMM D, h:mm A ";
      break;
    case "es":
      dateFormat = "LL, h:mm A ";
      break;
  }

  let duration = getDateFormatted(event, true);
  let additionalStatus = getAdditionalStatus(event, duration);
  let userLanguageTitle = event.localizeData.filter(e => e.locale.indexOf(userLanguage) != -1);
  let title = event.title;
  if(userLanguageTitle.length > 0) {
    console.log("userLanguageTitle", userLanguageTitle);
    title = userLanguageTitle[0].name
  }

  let type = '';
  if(event.tags?.indexOf('Group Session') != -1) {
    type = ASK_THE_EXPERT;
  } else if (event.tags?.indexOf('Workshop/Networking') != -1) {
    type = Hands_ON_HELP;
  } else if (event.tags?.indexOf('Office Hours') != -1) {
    type = COURSES_QA;
  } else if (event.tags?.indexOf('Community') != -1) {
    type = NETWORKING_SESSIONS;
  }

  if(event.tags?.indexOf(TAG_RECORDED_EVENTS) != -1) {
    let recordedEvent = createCourseObject(event, userLanguage);
    recordedEvent.format = 'Event';
    recordedEvent.isRecordedEvent = true;
    recordedEvent.type = type;
    return recordedEvent;
  }

  let skillLevel = [];
  event.skills?.forEach((skill) => {
    if(skill?.name && skill.level && skill.level != null) {
      skillLevel.push(`${skill?.name}:${skill?.level}`);
    }
  });

  let startDate = new Date(new Date(event.dateStart));

  const dateTimeStap = event.datePublished;
  const currentDate = new Date();
  const dateDiff = (currentDate - new Date(dateTimeStap)) / (1000 * 60 * 60 * 24);

  let tag="";
  if(event.locale?.indexOf('en-US') != -1 && event.locale?.indexOf('es-ES') != -1){
    tag= TAG_BILINGUAL;
   } else if (event.locale?.indexOf('es-ES') != -1 &&  userLanguage === "es"){
    tag= TAG_SPANISH;
  }else if (dateDiff <= 14){
    tag= TAG_JUST_ADDED;
  }

  return { 
    id: event.id,
    image: event.imageUrl, 
    additionalStatus: additionalStatus, 
    duration: duration, 
    title: title,
    status: '',
    showBookmarkIcon: true,
    startDate: new Date(new Date(event.dateStart)).toString(),
    endDate: new Date(new Date(startDate.getTime() + event.duration*1000)),
    location: locationForConf,
    availableSeats: event.availableSeats,
    tags:event.tags,
    enrollmentDeadline: event.enrollmentDeadline,
    recording: event.attachments,
    launchUrl: event.launchUrl,
    locale: event.locale,
    format: 'Event',
    tag:tag,
    type: type,
    isFinalDayEnrollment: additionalStatus.tagName == 'Final day to register',
    skillLevels: skillLevel,
    seatLimit: event.seatLimit,
    isRecordedEvent: event.tags?.indexOf(TAG_RECORDED_EVENTS) != -1
  }
}

let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

function inpersonEventDate(dateStart, duration, eventTimeZone,event) {
  const formatMonthLength = (m) => (m.length <= 4 ? m : m.slice(0, 3)).replace(/^\w/, c => c.toUpperCase());
  const instanceObj = event?.instances?.find((ins) => ins?.instanceId === event?.instanceIds?.[0]);

  let lng = localStorage.getItem('lng') === "es" ? "es-ES" : 'en-US';
  const startDate = new Date(new Date(dateStart));
  let endDate=null;
  if(instanceObj?.endDate && instanceObj){
    endDate = new Date(new Date(instanceObj?.endDate));
  }else{
    endDate = new Date(new Date(dateStart + duration * 1000));
  } 

  const optionsDate = { month: 'short', day: 'numeric', timeZone: eventTimeZone };
  const optionsDateTime = { ...optionsDate, hour: 'numeric', minute: 'numeric', hour12: true };

  const isMoreThan24Hours = duration > 24 * 3600; 
  const isMultiDayEvent = new Intl.DateTimeFormat(lng, optionsDate).formatToParts(startDate)?.find(p => p.type === 'day').value != new Intl.DateTimeFormat(lng, optionsDate).formatToParts(endDate)?.find(p => p.type === 'day').value;
 
  if (isMultiDayEvent || isMoreThan24Hours) {
    const startFormatted = new Intl.DateTimeFormat(lng, optionsDate).formatToParts(startDate);
    const endFormatted = new Intl.DateTimeFormat(lng, optionsDate).formatToParts(endDate);
    const starDay = startFormatted?.find(p => p.type === 'day').value;
    const endDay = endFormatted?.find(p => p.type === 'day').value;
    const startMonth = formatMonthLength(startFormatted?.find(p => p.type === 'month')?.value);
    const endMonth =formatMonthLength(endFormatted?.find(p => p.type === 'month')?.value);
    if(startMonth != endMonth){
      return `${startMonth} ${starDay} - ${endMonth} ${endDay}`;
    }else{
      return `${startMonth} ${starDay} - ${endDay}`;
    }
  } else {
    const formattedDateTime = new Intl.DateTimeFormat(lng, optionsDateTime).format(startDate);
    const timeZoneAbbreviation = getTimeZoneAbbreviation(startDate, eventTimeZone);
    return `${formattedDateTime} ${timeZoneAbbreviation}`;
  }
} 

const within24Hours = (enrollmentDeadline, timezone) => {
  const deadline = moment.tz(enrollmentDeadline, timezone);
  const currentTime = moment.tz(timezone);
  const diffInHours = deadline.diff(currentTime, "hours");
  return diffInHours >= 0 && diffInHours <= 24;
}

const createInPersonEventObject = (event, userLanguage) => {
  let locationForConferenceModule = event?.modules?.filter(e => e.location != null);
  let locationForConf = null;
  if(locationForConferenceModule?.length > 0) 
    locationForConf = locationForConferenceModule[0]?.location;
  let eventTimeZoneModule = event.modules ? event.modules.filter(e => e?.inPersonLocation?.timeZone?.zone != null) : [];
  let eventCityModule = event.modules ? event.modules.filter(e => e?.inPersonLocation?.metroArea != null) : [];
  let eventTimeZone = eventTimeZoneModule?.[0]?.inPersonLocation?.timeZone?.zone ?? userTimeZone;
  let eventCity = eventCityModule?.[0]?.inPersonLocation?.city ?? locationForConf;
  let eventMetroArea = eventCityModule?.[0]?.inPersonLocation?.metroArea ?? null;
  let isInPersonEvent = event?.format === "Classroom" ? true : false;

  //Change locale for date format
  moment.locale(userLanguage);
  let hostType = "";
  if(userLanguage === "en" && event.localizeData?.[0].hostDetails) {
    hostType = event.localizeData?.[0]?.hostDetails?.type ?? ""
  } else if(userLanguage === "es" && event?.localizeData?.[1]?.hostDetails) {
    hostType = event?.localizeData?.[1]?.hostDetails?.type ?? ""
  }
  switch(userLanguage) {
    case "en":
      dateFormat = "MMM D, h:mm a";
      break;
    case "es":
      dateFormat = "LL, h:mm a";
      break;
  }

  let duration = getDateFormatted(event);
  let additionalStatus = {};
  let isFinalDayEnrollment = event?.enrollmentDeadline !== null ? within24Hours(event?.enrollmentDeadline, eventTimeZone) : false;
  if(isFinalDayEnrollment) {
    additionalStatus = {
      tagName: FINAL_DAY_REGISTER, 
      color: DARK_ORANGE_COLOR
    };
  }
  let userLanguageTitle = event.localizeData.filter(e => e.locale.indexOf(userLanguage) != -1);
  let title = event.title;
  if(userLanguageTitle.length > 0) {
    title = userLanguageTitle[0].name
  }

  let type = '';
  if(event.tags?.indexOf('Group Session') != -1) {
    type = ASK_THE_EXPERT;
  } else if (event.tags?.indexOf('Workshop/Networking') != -1) {
    type = Hands_ON_HELP;
  } else if (event.tags?.indexOf('Office Hours') != -1) {
    type = COURSES_QA;
  } else if (event.tags?.indexOf('Community') != -1) {
    type = NETWORKING_SESSIONS;
  }

  let skillLevel = [];
  event.skills?.forEach((skill) => {
    if(skill?.name && skill.level && skill.level != null) {
      skillLevel.push(`${skill?.name}:${skill?.level}`);
    }
  });

  let startDate = new Date(new Date(event.dateStart).toLocaleString('en-US', { timeZone: userTimeZone }));
  let cardDate = inpersonEventDate(event.dateStart, event.duration, eventTimeZone,event);


  const dateTimeStap = event.datePublished;
  const currentDate = new Date();
  const dateDiff = (currentDate - new Date(dateTimeStap)) / (1000 * 60 * 60 * 24);

  let tag="";
  if(event.locale?.indexOf('en-US') != -1 && event.locale?.indexOf('es-ES') != -1){
    tag= TAG_BILINGUAL;
   } else if (event.locale?.indexOf('es-ES') != -1 &&  userLanguage === "es"){
    tag= TAG_SPANISH;
  }else if (dateDiff <= 30){
    tag= TAG_JUST_ADDED;
  }

  return { 
    id: event.id,
    image: event.imageUrl, 
    additionalStatus: additionalStatus, 
    duration: duration, 
    title: title,
    status: '',
    showBookmarkIcon: true,
    startDate: startDate,
    endDate: new Date(new Date(event.dateStart + event.duration*1000).toLocaleString('en-US', { timeZone: userTimeZone })),
    location: locationForConf,
    availableSeats: event.availableSeats,
    tags:event.tags,
    enrollmentDeadline: event.enrollmentDeadline,
    recording: event.attachments,
    launchUrl: event.launchUrl,
    locale: event.locale,
    format: 'Event',
    tag:tag,
    type: type,
    hostType: hostType,
    isFinalDayEnrollment: isFinalDayEnrollment,
    skillLevels: skillLevel,
    seatLimit: event.seatLimit,
    isInPersonEvent : isInPersonEvent,
    eventCity: eventCity,
    eventTimeZone: eventTimeZone,
    cardDate: cardDate, 
    eventMetroArea: eventMetroArea
  }
}


function getDateFormatted(event, isAddTimeZone = false) {
  let startTime = new Date(event.dateStart);
  let endTime = new Date(event.completionDeadline);
  let formattedDate = "";
  let tileViewTime = "";
  let colorForDate = DEFAULT_COLOR;

  let momentStartTime = moment(startTime);
  let momentEndTime = moment(endTime);
  const timeZoneAbbreviation = getTimeZoneAbbreviation(momentStartTime, userTimeZone);
  localStorage.setItem('timeZoneAbbreviation', timeZoneAbbreviation);
  if(isAddTimeZone)
  {
    if(startTime.getDate() != endTime.getDate()) {
      formattedDate = momentStartTime.tz(userTimeZone).format(dateFormat) + timeZoneAbbreviation + "-" + momentEndTime.format(dateFormat) + timeZoneAbbreviation;
    } else {
      formattedDate = momentStartTime.tz(userTimeZone).format(dateFormat) + timeZoneAbbreviation + "-" + momentEndTime.format('h:mm a')
    }
    tileViewTime = momentStartTime.tz(userTimeZone).format(dateFormat)+ timeZoneAbbreviation;
  }
  else{
      if(startTime.getDate() != endTime.getDate()) {
        formattedDate = momentStartTime.tz(userTimeZone).format(dateFormat) + "-" + momentEndTime.tz(userTimeZone).format(dateFormat);
      } else {
        formattedDate = momentStartTime.tz(userTimeZone).format(dateFormat) + "-" + momentEndTime.tz(userTimeZone).format('h:mm a')
      }
      tileViewTime = momentStartTime.tz(userTimeZone).format(dateFormat);
  }
  return {
    dateTime: formattedDate, 
    tileViewTime: tileViewTime,
    color: colorForDate, 
    timeInMinutes: Math.floor(moment.duration(momentStartTime.diff(moment(new Date()))).asMinutes()),
    timeInSeconds: Math.floor(moment.duration(momentStartTime.diff(moment(new Date()))).asSeconds()),
    timeInHours: Math.floor(moment.duration(momentStartTime.diff(moment(new Date()))).asHours())
  };
}

const generateTimeZoneAbbreviations = () => {
  const abbreviations = {};
  const timeZones = Intl.supportedValuesOf('timeZone');
  timeZones.forEach((timeZone) => {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'short',
    });
    const parts = formatter.formatToParts(new Date());
    const timeZonePart = parts.find((part) => part.type === 'timeZoneName');
    if (timeZonePart) {
      const abbreviation = timeZonePart.value;
      abbreviations[abbreviation] = abbreviation.length === 3 ? abbreviation[0] + 'T' : abbreviation;
    }
  });

  abbreviations['GMT+5:30'] = 'IT'; // Map GMT+5:30 to IT (for IST)
  return abbreviations;
};

const timezoneAbbreviations2Letter = generateTimeZoneAbbreviations();

const getTimeZoneAbbreviation = (date, timeZone) => {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    timeZoneName: 'short',
  });
  const parts = formatter.formatToParts(date);
  const timeZonePart = parts.find((part) => part.type === 'timeZoneName');
  const tzAbbreviation = timeZonePart ? timeZonePart.value : '';
  return timezoneAbbreviations2Letter[tzAbbreviation] || tzAbbreviation;
};

function formatEventTime(eventDetails,userTimeZone, isInPersonEvent = false) {
  let lng = localStorage.getItem('lng') ?? 'en';
  const instanceObj = eventDetails?.instances?.find((ins) => ins?.instanceId === eventDetails?.instanceIds?.[0]);

    const parseDate = (dateString) => {
      const date = new Date(dateString);
      if (isNaN(date)) {
        throw new Error(`Invalid date: ${dateString}`);
      }
      return date;
    };

    const startTime = parseDate(eventDetails.dateStart);
    const endTime =  (instanceObj && instanceObj?.endDate && eventDetails?.format === "Classroom") ? parseDate(instanceObj?.endDate) : new Date(startTime.getTime() + eventDetails.duration * 1000);

     // Dynamically determine the time zone
    const timeZone = isInPersonEvent
     ? eventDetails?.modules?.[0]?.inPersonLocation?.timeZone?.zone || userTimeZone 
     : userTimeZone; // Use userTimeZone for other events

    const formatDate = (date, includePeriod = true) => {
      const formatter = new Intl.DateTimeFormat('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZone: timeZone,
      });
      const roundToNearestQuarter = (minute) => {
        const quarters = [0, 15, 30, 45];
        return quarters.reduce((prev, curr) => Math.abs(curr - minute) < Math.abs(prev - minute) ? curr : prev);
      };
  
      const parts = formatter.formatToParts(date);
      const day = parts.find((part) => part.type === 'weekday').value;
      const month = parts.find((part) => part.type === 'month').value;
      const dayOfMonth = parts.find((part) => part.type === 'day').value;
      const hour = parts.find((part) => part.type === 'hour').value;
      const minute = parts.find((part) => part.type === 'minute').value;
      const period = includePeriod ? parts.find((part) => part.type === 'dayPeriod').value : '';
      const roundedMinute = roundToNearestQuarter(parseInt(minute, 10));
      const time = roundedMinute === 0 ? `${hour}:00` : `${hour}:${roundedMinute}`;
      return { day, month, dayOfMonth, time, period };
    };

    const startFormatted = formatDate(startTime);
    const endFormatted = formatDate(endTime, true);
    const timeZoneAbbreviation = getTimeZoneAbbreviation(startTime, timeZone);
  
    // If both times fall within the same 12-hour period, exclude AM/PM from the start time
    const timeRange =
      startFormatted.period === endFormatted.period
        ? `${startFormatted.time}-${endFormatted.time} ${endFormatted.period}`
        : `${startFormatted.time} ${startFormatted.period}-${endFormatted.time} ${endFormatted.period}`;
    if(lng === 'en'){
      if(isInPersonEvent && (startFormatted.dayOfMonth != endFormatted.dayOfMonth)){
        return `${startFormatted.month} ${startFormatted.dayOfMonth}, ${startFormatted.time} ${startFormatted.period} - ${endFormatted.month} ${endFormatted.dayOfMonth}, ${endFormatted.time} ${endFormatted.period} ${timeZoneAbbreviation}`;
      }else{
        return `${startFormatted.day}, ${startFormatted.month} ${startFormatted.dayOfMonth}: ${timeRange} ${timeZoneAbbreviation}`;
      }
  }
  else if(lng === "es"){
    //start date
    const date = new Date(eventDetails.dateStart);
    const options = { weekday: 'short',day: 'numeric', month: 'short', year: 'numeric', timeZone: timeZone, };
    const parts = new Intl.DateTimeFormat('es-ES', options).formatToParts(date);
    const day = parts.find(part => part.type === 'day').value;
    const monthSmall = parts.find(part => part.type === 'month').value.slice(0, 3).toLowerCase();
    const month = monthSmall?.charAt(0).toUpperCase() + monthSmall?.slice(1);
    const weekday = parts.find(part => part.type === 'weekday')?.value;

    const year = parts.find(part => part.type === 'year').value;
    //End date
    const date2 = new Date(endTime);
    const options2 = {weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', timeZone: timeZone, };
    const parts2 = new Intl.DateTimeFormat('es-ES', options2).formatToParts(date2);
    const day2 = parts2.find(part => part.type === 'day').value;
    const monthSmall2 =parts2.find(part => part.type === 'month').value.slice(0, 3).toLowerCase();
    const month2 = monthSmall2?.charAt(0).toUpperCase() + monthSmall2?.slice(1);

    if(isInPersonEvent){
      if(day2!=day){
        return `${month} ${day}, ${startFormatted.time} ${startFormatted.period} - ${month2} ${day2}, ${endFormatted.time} ${endFormatted.period} ${timeZoneAbbreviation} `;
      }else{
        return `${weekday?.replace(/^\w/, c => c.toUpperCase())}, ${day} de ${month}: ${timeRange} ${timeZoneAbbreviation}`;
      }

      // return `${day} de ${month} de ${year}: ${timeRange} ${timeZoneAbbreviation}`;
    }else{
      return `${day} de ${month} de ${year}: ${timeRange} ${timeZoneAbbreviation}`;
    }
  }
}



function compareDates(a, b) {
  let aStartTime = a.dateStart;
  let bStartTime = b.dateStart;
  if(aStartTime < bStartTime) {
    return -1;
  } else if(aStartTime > bStartTime) {
    return 1;
  }
  return 0;
}

const getAdditionalStatus = (event, duration) => {

  let additionalStatus = {};  
  if(event.availableSeats <= 0 && event.seatLimit != 0) {
    additionalStatus = {
      tagName: EVENT_FULL_JOIN_WAITLIST_TEXT,
      color: DARK_ORANGE_COLOR,
      registeredIcon: 'calendar'
    };
  }
  if(event.availableSeats > 0 && event.availableSeats < SEATS_THRESHHOLD) {
    const seatsLeftText = event.availableSeats==1 ? ONE_SEATS_LEFT_TEXT : SEATS_LEFT_TEXT
    additionalStatus = {
      tagName: `${event.availableSeats} ${seatsLeftText}`, 
      color: DARK_ORANGE_COLOR,
      registeredIcon: 'calendar'
    };
  }
    if(duration?.timeInHours <= HOURS_TO_SHOW_STARTS_SOON) {
      additionalStatus = {
      tagName: STATUS_START_SOON, 
      color: DARK_ORANGE_COLOR,
      registeredIcon: 'calendar'
    };
  }
  if(duration?.timeInHours <= HOURS_TO_SHOW_STARTS_SOON && event?.enrollmentDeadline != null ) {
    additionalStatus = {
      registeredIcon: 'calendar',
      tagName: LAST_DAY_TO_ENROLL, 
      color: DARK_ORANGE_COLOR
    };
  }
  if (duration.timeInSeconds <= 0) {
    additionalStatus = {
      tagIcon: HIS_ICON, 
      tagName: STATUS_ENDED, 
      color: BROWN_COLOR,
      registeredIcon: ''
    };
  }
  if(event.enrollmentDeadline != null && event.enrollmentDeadline <= new Date().getTime()) {
    additionalStatus = {
      registeredIcon: 'calendar',
      tagName: REGISTRATION_CLOSED,
      color: BROWN_COLOR
    };
  }
  return additionalStatus;
}

const getRecommended = (attr, recommendedCourses, courses, inProgressIds ) => {
  console.log(inProgressIds, '=> inProgressIds')
  const inProgressCourses = inProgressIds.map(item =>  courses.find(course => course.id === item)).filter(item => item!== undefined)
  console.log(inProgressCourses, '=> inProgressCourses')
  const attrCourses =  attr.reduce((accum, item) => {
    const arr = recommendedCourses[item]??[]
    const data = arr.reduce((acc, courseId) => {
      const obj = courses.find(course => course.id === courseId)
      if(obj){
        acc.push(obj)
      }
        return acc
    }, [])
    accum = [...accum, ...data]
    return accum
  }, [])

  const data = ([...inProgressCourses, ...attrCourses]).filter((item, index, array) => array.findIndex(subItem => subItem.id === item.id) === index)
  return data;
 
}
const getRecommendedResults = (attr, recommendedCourses, courses ) => {
  //console.log(inProgressIds, '=> inProgressIds')
 // const inProgressCourses = inProgressIds.map(item =>  courses.find(course => course.id === item)).filter(item => item!== undefined)
 // console.log(inProgressCourses, '=> inProgressCourses')
  const attrCourses =  attr.reduce((accum, item) => {
    const arr = recommendedCourses[item]??[]
    const data = arr.reduce((acc, courseId) => {
      const obj = courses.find(course => course.id === courseId)
      if(obj){
        acc.push(obj)
      }
        return acc
    }, [])
    accum = [...accum, ...data]
    return accum
  }, [])

  const data = ([...attrCourses]).filter((item, index, array) => array.findIndex(subItem => subItem.id === item.id) === index)
  return data;
 
}

const getSuggestedEnglish = (enrollments, suggestions, userDataFromStore, recommendedCourses, count=12) => {
  const courses = Object.values((suggestions).courses??{}).filter(item => (item.locale??[]).includes('en-US'))
  console.log("suggestions api courses", courses);  
  const attributes = userDataFromStore.business?.attributes??{}
  const inProgressIds = (enrollments??[]).filter(item => item.attributes.state === "STARTED").sort((a,b) => new Date(b.attributes?.dateEnrolled??'') - new Date(a.attributes?.dateEnrolled??''))
  .map(item => item.relationships?.learningObject?.data?.id??'' ).filter(item => item !== '')
  let attr = Object.keys(attributes).filter(key => attributes[key] === 'Yes')
  if(!attr.includes("I'm not sure")){
      attr = [...attr, "I'm not sure"]
  }
  
  const recommended = (getRecommended(attr, recommendedCourses, courses, inProgressIds )??[]).slice(0, count)
  const newCourses = Object.values(courses).sort((a,b) => new Date(b.datePublished) - new Date(a.datePublished)).slice(0, count)
  const popular = Object.values(courses).sort((a,b)=> (b.enrollmentCount) - (a.enrollmentCount)).slice(0,count);
  return {
    recommended,
    newCourses,
    popular
  }
}


const getSuggestedSpanish = (enrollments, suggestions, userDataFromStore, recommendedCourses, count=12) => {
  const courses = Object.values((suggestions).courses??{}) 
  const spanishCourses = courses.filter(item => (item.locale??[]).includes('es-ES')) 
  const englishCourses = courses.filter(item => (item.locale??[]).includes('en-US')) 
  const finalCourses = [...spanishCourses, ...englishCourses]
  const attributes = userDataFromStore.business?.attributes??{}
  const inProgressIds = (enrollments??[]).filter(item => item.attributes.state === "STARTED").sort((a,b) => new Date(b.attributes?.dateEnrolled??'') - new Date(a.attributes?.dateEnrolled??''))
  .map(item => item.relationships?.learningObject?.data?.id??'' ).filter(item => item !== '')
  console.log("inProgressIds",inProgressIds);
  let attr = Object.keys(attributes).filter(key => attributes[key] === 'Yes')
  if(!attr.includes("I'm not sure")){
      attr = [...attr, "I'm not sure"]
  }
  
  const recommendedSpanish = (getRecommended(attr, recommendedCourses, spanishCourses, inProgressIds )??[])
  const recommendedEnglish = (getRecommended(attr, recommendedCourses, englishCourses, inProgressIds )??[])
  const recommended = ([...recommendedSpanish, ...recommendedEnglish]).slice(0, count)
  const newCourses = Object.values(finalCourses).sort((a,b) => new Date(b.datePublished) - new Date(a.datePublished)).slice(0, count)
  const popular = Object.values(finalCourses).sort((a,b)=> (b.enrollmentCount) - (a.enrollmentCount)).slice(0,count);
  return {
    recommended,
    newCourses,
    popular
  }
}
const getSuggestedEnglishbyTopic = ( suggestions, topicsOfInterest, recommendedCourses) => {
  console.log("suggestions api courses", suggestions);  
  const courses = suggestions
  //Object.values((suggestions).courses??{}).filter(item => (item.locale??[]).includes('en-US'))
  let count=courses?.length;
  console.log("suggestions api courses", courses);  
  //const attributes = topicsOfInterest
  //const inProgressIds = (enrollments??[]).filter(item => item.attributes.state === "STARTED").sort((a,b) => new Date(b.attributes?.dateEnrolled??'') - new Date(a.attributes?.dateEnrolled??''))
 // .map(item => item.relationships?.learningObject?.data?.id??'' ).filter(item => item !== '')
  let attr = topicsOfInterest
  if(!attr.includes("I'm not sure")){
      attr = [...attr, "I'm not sure"]
  }
  
  const recommended = (getRecommendedResults(attr, recommendedCourses, courses )??[]).slice(0, count)
  const newCourses = Object.values(courses).sort((a,b) => new Date(b.datePublished) - new Date(a.datePublished)).slice(0, count)
  const popular = Object.values(courses).sort((a,b)=> (b.enrollmentCount) - (a.enrollmentCount)).slice(0,count);
  console.log()
  return {
    recommended,
    newCourses,
    popular
  }
//   console.log("Suggestions",suggestions)
//   const courses = Object.values((suggestions??[]).courses)
//   console.log("suggestions api courses", courses);  
//  // const attributes = userDataFromStore.business?.attributes??{}
//   //const inProgressIds = (enrollments??[]).filter(item => item.attributes.state === "STARTED").sort((a,b) => new Date(b.attributes?.dateEnrolled??'') - new Date(a.attributes?.dateEnrolled??''))
//  // .map(item => item.relationships?.learningObject?.data?.id??'' ).filter(item => item !== '')
//   let attr = topicsOfInterest
//   if(!attr.includes("I'm not sure")){
//       attr = [...attr, "I'm not sure"]
//   }
  
//   const recommended = (getRecommendedResults(attr, recommendedCourses, courses )??[]).slice(0, count)
//   const newCourses = Object.values(courses).sort((a,b) => new Date(b.datePublished) - new Date(a.datePublished)).slice(0, count)
//   const popular = Object.values(courses).sort((a,b)=> (b.enrollmentCount) - (a.enrollmentCount)).slice(0,count);
//   return {
//     recommended,
//     newCourses,
//     popular
//   }
}


const getSuggestedSpanishbyTopic = ( suggestions, topicsOfInterest, recommendedCourses) => {
  const courses = suggestions
  //Object.values((suggestions).courses??{}) 
  const spanishCourses = courses.filter(item => (item.locale??[]).includes('es-ES')) 
  const englishCourses = courses.filter(item => (item.locale??[]).includes('en-US')) 
  const finalCourses = [...spanishCourses, ...englishCourses]
  let count=courses.length;
 // const attributes = userDataFromStore.business?.attributes??{}
  // const inProgressIds = (enrollments??[]).filter(item => item.attributes.state === "STARTED").sort((a,b) => new Date(b.attributes?.dateEnrolled??'') - new Date(a.attributes?.dateEnrolled??''))
  // .map(item => item.relationships?.learningObject?.data?.id??'' ).filter(item => item !== '')
 // console.log("inProgressIds",inProgressIds);
  let attr = topicsOfInterest
  if(!attr.includes("I'm not sure")){
      attr = [...attr, "I'm not sure"]
  }
  
  const recommendedSpanish = (getRecommendedResults(attr, recommendedCourses, spanishCourses )??[])
  const recommendedEnglish = (getRecommendedResults(attr, recommendedCourses, englishCourses )??[])
  const recommended = ([...recommendedSpanish, ...recommendedEnglish]).slice(0, count)
  // const newCourses = Object.values(finalCourses).sort((a,b) => new Date(b.datePublished) - new Date(a.datePublished)).slice(0, count)
  // const popular = Object.values(finalCourses).sort((a,b)=> (b.enrollmentCount) - (a.enrollmentCount)).slice(0,count);
  const sortedCourses = Object.values(englishCourses).sort((a,b) => new Date(b.datePublished) - new Date(a.datePublished)).slice(0, count)
  const newCourses = [...spanishCourses, ...sortedCourses]
  const sortedPopular = Object.values(englishCourses).sort((a,b)=> (b.enrollmentCount) - (a.enrollmentCount)).slice(0,count);
  const popular =  [...spanishCourses, ...sortedPopular]
  return {
    recommended,
    newCourses,
    popular
  }
//   const courses = Object.values((suggestions??[]).courses) 
//   const spanishCourses = courses.filter(item => (item.locale??[]).includes('es-ES')) 
//   const englishCourses = courses.filter(item => (item.locale??[]).includes('en-US')) 
//   const finalCourses = [...spanishCourses, ...englishCourses]
//  // const attributes = userDataFromStore.business?.attributes??{}
//   // const inProgressIds = (enrollments??[]).filter(item => item.attributes.state === "STARTED").sort((a,b) => new Date(b.attributes?.dateEnrolled??'') - new Date(a.attributes?.dateEnrolled??''))
//   // .map(item => item.relationships?.learningObject?.data?.id??'' ).filter(item => item !== '')
//   let attr = topicsOfInterest
//   if(!attr.includes("I'm not sure")){
//       attr = [...attr, "I'm not sure"]
//   }
  
//   const recommended = (getRecommendedResults(attr, recommendedCourses, finalCourses )??[]).slice(0, count)
//   const newCourses = Object.values(finalCourses).sort((a,b) => new Date(b.datePublished) - new Date(a.datePublished)).slice(0, count)
//   const popular = Object.values(finalCourses).sort((a,b)=> (b.enrollmentCount) - (a.enrollmentCount)).slice(0,count);
//   return {
//     recommended,
//     newCourses,
//     popular
//   }
}
const getSuggestedCourses = (lng, enrollments, suggestions, userDataFromStore, recommendedCourses, count=12) => {

 if(lng === 'en'){
  const data = getSuggestedEnglish( enrollments, suggestions, userDataFromStore, recommendedCourses, count)
  return data;
 }
 

 const data = getSuggestedSpanish( enrollments, suggestions, userDataFromStore, recommendedCourses, count)
  return data;
}
const getSuggestedCoursesbyTopic = (lng, suggestions, topicsOfInterest, recommendedCourses, count=12) => {
console.log("result.data",suggestions)
  if(lng === 'en'){
   const data = getSuggestedEnglishbyTopic( suggestions, topicsOfInterest, recommendedCourses, count)
   return data;
  }
  
 
  const data = getSuggestedSpanishbyTopic( suggestions, topicsOfInterest, recommendedCourses, count)
   return data;
 }

const getRecommendedByMultiTopic = (attr, recommendedCourses, courses) => {

  const topicAttrs = attr.filter(topic => topic !== "I'm not sure");
  const notSureTopic = attr.find(topic => topic === "I'm not sure");

  const perTopicCourses = topicAttrs.map(topic => {
    const arr = recommendedCourses[topic] ?? [];
    return arr.reduce((acc, courseId) => {
      const obj = courses.find(course => course.id === courseId);
      if (obj) {
        acc.push(cloneDeep(obj));
      }
      return acc;
    }, []);
  });

  //round-robin pick one from each topic
  const roundRobinCourses = [];
  const maxLen = Math.max(...perTopicCourses.map(arr => arr.length), 0);
  for (let i = 0; i < maxLen; i++) {
    for (let t = 0; t < perTopicCourses.length; t++) {
      if (i < perTopicCourses[t].length) {
        roundRobinCourses.push(perTopicCourses[t][i]);
      }
    }
  }
  // I am not sure courses
  const notSureCourses = notSureTopic
    ? (recommendedCourses[notSureTopic] ?? []).reduce((acc, courseId) => {
        const obj = courses.find(course => course.id === courseId);
        if (obj) {
          acc.push(cloneDeep(obj));
        }
        return acc;
      }, [])
    : [];

  // RoundRobin for topics, then "I'm not sure", deduplicated
  const data = cloneDeep([...roundRobinCourses, ...notSureCourses]).filter(
    (item, index, array) => array.findIndex(subItem => subItem.id === item.id) === index
  );

  console.log("^^Recommended by multi topic", { attr, data });
  return data;
};

const getForceRankedCourses = (lng, courses, topics, recommendedCourses, excludeCourseId = null, count = 6) => {
  const filteredCourses = excludeCourseId
    ? courses?.filter(c => c.id !== excludeCourseId)
    : courses;

  let attr = Array.isArray(topics) ? cloneDeep(topics) : cloneDeep([topics]);
  if (!attr.includes("I'm not sure")) {
    attr = [...attr, "I'm not sure"];
  }

  let recommended;

  if (lng === 'en') {
    recommended = getRecommendedByMultiTopic(attr, recommendedCourses, filteredCourses) ?? [];
  } else {
    const spanishCourses = filteredCourses.filter(item => (item.locale ?? []).includes('es-ES'));
    const englishCourses = filteredCourses.filter(item => (item.locale ?? []).includes('en-US'));

    const recommendedSpanish = getRecommendedByMultiTopic(attr, recommendedCourses, spanishCourses) ?? [];
    const recommendedEnglish = getRecommendedByMultiTopic(attr, recommendedCourses, englishCourses) ?? [];
    recommended = [...recommendedSpanish, ...recommendedEnglish];
  }

  const topicFiltered = recommended.filter(e =>
    e.tags?.some(tag => attr.some(topic => tag?.toLowerCase() === topic?.toLowerCase()))
  );

  return topicFiltered
    .filter((item, index, self) => index === self.findIndex(t => t.id === item.id))
    .slice(0, count);
};

const recommendedEvents = (events, selectedTopicsOfInterest, language, limit) => {
  let sortedEvents = [];
  switch (language) {
    case "en":
      if(events?.length){
        sortedEvents = events.filter(e=>selectedTopicsOfInterest.some(r=> e.tags?.includes(r)));
        let firstOccurence = null;
        sortedEvents.every((event, index) => {
          if(event.availableSeats > 0 || event.seatLimit == 0) {
            firstOccurence = index;
            return false;
          }
          return true;
        });
        if(firstOccurence != null) {
          let availableItem = sortedEvents.splice(firstOccurence, 1);
          sortedEvents = [availableItem[0], ...sortedEvents];
        }
      }
      break;
    case "es":
      if(events?.length){
        sortedEvents = recommenededSpanish(events, selectedTopicsOfInterest, limit);
      }
      break;
  }
  return sortedEvents;
}

const recommenededSpanish = (events, selectedTopicsOfInterest, limit) => {
  let firstEventForSpanish = null;
  let spanishEventWithTOI = [];
  let spanishSeatAvailable = [];
  let spanishWaitlist = [];
  let englishEventWithTOI = [];
  let englishSeatAvailable = [];
  let englishWaitlist = [];
  let sortedEvents = [];

  if(!selectedTopicsOfInterest.includes("I'm not sure")) {
    events.forEach((event) => {
      let matchesTOI = selectedTopicsOfInterest.some(r=> event.tags?.includes(r));
      if(event.locale.indexOf("es-ES") != -1) {
        if(matchesTOI) {
          if(event.availableSeats > 0 || event.seatLimit == 0) {
            if(firstEventForSpanish == null) {
              firstEventForSpanish = event;
            } else {
              spanishEventWithTOI.push(event);
            }
          } else {
            spanishEventWithTOI.push(event);
          }
        } else {
          if(event.availableSeats > 0 || event.seatLimit == 0) {
            spanishSeatAvailable.push(event);
          } else {
            spanishWaitlist.push(event);
          }
        }
      } else {
        if(matchesTOI) {
          englishEventWithTOI.push(event);
        } else {
          if(event.availableSeats > 0 || event.seatLimit == 0) {
            englishSeatAvailable.push(event);
          } else {
            englishWaitlist.push(event);
          }
        }
      }
    });

    if(firstEventForSpanish == null) {
      if(spanishSeatAvailable.length > 0) {
        firstEventForSpanish = spanishSeatAvailable.splice(0, 1);
      }
    }

    if(firstEventForSpanish != null && firstEventForSpanish.length > 0) {
      sortedEvents = [firstEventForSpanish[0]];
    }

    if(spanishEventWithTOI.length <= limit) {
      sortedEvents = sortedEvents.concat(spanishEventWithTOI);
    } else {
      sortedEvents = sortedEvents.concat(spanishEventWithTOI.splice(0,limit));
    }
    
    let remainingEventToReachLimit = limit - sortedEvents.length;
    if(remainingEventToReachLimit > 0) {
      if(spanishSeatAvailable.length <= remainingEventToReachLimit) {
        sortedEvents = sortedEvents.concat(spanishSeatAvailable);
      } else {
        sortedEvents = sortedEvents.concat(spanishSeatAvailable.splice(0,remainingEventToReachLimit));
      }
    } else {
      return sortedEvents;
    }

    remainingEventToReachLimit = limit - sortedEvents.length;
    if(remainingEventToReachLimit > 0) {
      if(spanishWaitlist.length <= remainingEventToReachLimit) {
        sortedEvents = sortedEvents.concat(spanishWaitlist);
      } else {
        sortedEvents = sortedEvents.concat(spanishWaitlist.splice(0,remainingEventToReachLimit));
      }
    } else {
      return sortedEvents;
    }

    remainingEventToReachLimit = limit - sortedEvents.length;
    if(remainingEventToReachLimit > 0) {
      if(englishEventWithTOI.length <= remainingEventToReachLimit) {
        sortedEvents = sortedEvents.concat(englishEventWithTOI);
      } else {
        sortedEvents = sortedEvents.concat(englishEventWithTOI.splice(0,remainingEventToReachLimit));
      }
    } else {
      return sortedEvents;
    }

    remainingEventToReachLimit = limit - sortedEvents.length;
    if(remainingEventToReachLimit > 0) {
      if(englishSeatAvailable.length <= remainingEventToReachLimit) {
        sortedEvents = sortedEvents.concat(englishSeatAvailable);
      } else {
        sortedEvents = sortedEvents.concat(englishSeatAvailable.splice(0,remainingEventToReachLimit));
      }
    } else {
      return sortedEvents;
    }

    remainingEventToReachLimit = limit - sortedEvents.length;
    if(remainingEventToReachLimit > 0) {
      if(englishWaitlist.length <= remainingEventToReachLimit) {
        sortedEvents = sortedEvents.concat(englishWaitlist);
      } else {
        sortedEvents = sortedEvents.concat(englishWaitlist.splice(0,remainingEventToReachLimit));
      }
    } else {
      return sortedEvents;
    }
  } else {
    let spanishEvents = [];
    let englishEvents = [];
    let remainingEventToReachLimit = limit - sortedEvents.length;

    events.forEach((event) => {
      if(event.locale.indexOf("es-ES") != -1) {
        spanishEvents.push(event);
      } else {
        englishEvents.push(event);
      }
    });

    if(spanishEvents.length <= limit) {
      sortedEvents = sortedEvents.concat(spanishEvents);
    } else {
      sortedEvents = sortedEvents.concat(spanishEvents.splice(0,limit));
    }

    remainingEventToReachLimit = limit - sortedEvents.length;
    if(remainingEventToReachLimit > 0) {
      if(englishEvents.length <= remainingEventToReachLimit) {
        sortedEvents = sortedEvents.concat(englishEvents);
      } else {
        sortedEvents = sortedEvents.concat(englishEvents.splice(0,remainingEventToReachLimit));
      }
    } else {
      return sortedEvents;
    }
  }

  return sortedEvents;
}

const comingSoonEvents = (events, selectedTopicsOfInterest, language, isAuthenticatedUser, limit, recommendedEventList, upcomingEvents) => {
  
  switch (language) {
    case "en":
      return comingSoonEnglishEvents(events, selectedTopicsOfInterest, isAuthenticatedUser, limit, recommendedEventList, upcomingEvents);
    
    case "es":
      return comingSoonSpanishEvents(events, selectedTopicsOfInterest, isAuthenticatedUser, limit, upcomingEvents);
  }
}

const comingSoonEnglishEvents = (events, selectedTopicsOfInterest, isAuthenticatedUser, limit, recommendedEventList, upcomingEvents) => {
  let sortedEvents = [];
  let registeredEvents = [];
  let waitListedEvents = [];
  let sortedEventCourseId = [];
  let upcomingEventsWithoutAvailability = [];
 

  //Reusing recommendedEventList
  let sortedEventsLength = sortedEvents.length;
  if(!recommendedEventList || recommendedEventList.length == 0) {
    recommendedEventList = recommendedEvents(events, selectedTopicsOfInterest, "en", limit);
  }
  recommendedEventList.forEach((event) => {
    if(event.availableSeats > 0 || event.seatLimit == 0) {
      if(event.enrollmentDeadline == null || event.enrollmentDeadline >= new Date().getTime()) {
        sortedEventCourseId.push(event.id);
        sortedEvents = [...sortedEvents, event];
        sortedEventsLength = sortedEventsLength + 1;
      }
    } else {
      upcomingEventsWithoutAvailability.push(event);
    }
    if(sortedEventsLength >= limit)
      return sortedEvents;
  });

  //Upcoming events with open registration
  upcomingEvents.forEach((event) => {
    if(sortedEventCourseId.indexOf(event.id) == -1  && (event.availableSeats > 0 || event.seatLimit == 0)) {
      if(event.enrollmentDeadline == null || event.enrollmentDeadline >= new Date().getTime()) {
        sortedEventCourseId.push(event.id);
        sortedEvents = [...sortedEvents, event];
        sortedEventsLength = sortedEventsLength + 1;
      }
    } 
    if(sortedEventsLength >= limit)
      return sortedEvents;
  });

  //upcoming events full and availabe inidicator to add to waitlist
  console.log("sortedEvents.length", sortedEvents.length);
  console.log("upcomingEventsWithoutAvailability", upcomingEventsWithoutAvailability);
  if(upcomingEventsWithoutAvailability.length > 0)
    sortedEvents = sortedEvents.concat(upcomingEventsWithoutAvailability.splice(0, (limit - sortedEvents.length)));

  return sortedEvents;
}

const comingSoonSpanishEvents = (events, selectedTopicsOfInterest, isAuthenticatedUser, limit, upcomingEvents) => {
  let sortedEvents = [];
  let registeredEvents = [];
  let waitListedEvents = [];
  let spanishEventApproachingCapacityAndDeadline = [];
  let spanishEventApproachingCapacityAndDeadlineTOI = [];
  let englishEventApproachingCapacityAndDeadlineTOI = [];
  let englishEventApproachingCapacityAndDeadline = [];
  let spanishWLTOI = [];
  let spanishWL = [];
  let englishWLTOI =[];
  let englishWL = [];

 

  // event.enrollmentStatus == "NOT_ENROLLED" && event.availableSeats > 0) {
  //   if(event.enrollmentDeadline == null || event.enrollmentDeadline >= new Date().getTime()) {

  upcomingEvents.forEach((event) => {
    let matchesTOI = selectedTopicsOfInterest.some(r=> event.tags?.includes(r));
    if(event.locale.indexOf("es-ES") != -1) {
      // if(event.enrollmentStatus == "NOT_ENROLLED") {
        if(event.availableSeats > 0 || event.seatLimit == 0) {
          if(event.enrollmentDeadline == null || event.enrollmentDeadline >= new Date().getTime()) {
            if(matchesTOI) {
              spanishEventApproachingCapacityAndDeadlineTOI.push(event);
            } else {
              spanishEventApproachingCapacityAndDeadline.push(event);
            }
          } else {
            if(matchesTOI) {
              spanishEventApproachingCapacityAndDeadlineTOI.push(event);
            } else {
              spanishEventApproachingCapacityAndDeadline.push(event);
            }
          }
        } else {
          if(matchesTOI) {
            spanishWLTOI.push(event);
          } else {
            spanishWL.push(event);
          }
        }
      //}
    } else {
     // if(event.enrollmentStatus == "NOT_ENROLLED") {
        if(event.availableSeats > 0 || event.seatLimit == 0) {
          if(event.enrollmentDeadline == null || event.enrollmentDeadline >= new Date().getTime()) {
            if(matchesTOI) {
              englishEventApproachingCapacityAndDeadlineTOI.push(event);
            } else {
              englishEventApproachingCapacityAndDeadline.push(event);
            }
          } else {
            if(matchesTOI) {
              englishEventApproachingCapacityAndDeadlineTOI.push(event);
            } else {
              englishEventApproachingCapacityAndDeadline.push(event);
            }
          }
        } else {
          if(matchesTOI) {
            englishWLTOI.push(event);
          } else {
            englishWL.push(event);
          }
        }
      //}
    }
  });

  let remainingEventToReachLimit = limit - sortedEvents.length;
  if(remainingEventToReachLimit > 0) {
    if(spanishEventApproachingCapacityAndDeadlineTOI.length <= remainingEventToReachLimit) {
      sortedEvents = sortedEvents.concat(spanishEventApproachingCapacityAndDeadlineTOI);
    } else {
      sortedEvents = sortedEvents.concat(spanishEventApproachingCapacityAndDeadlineTOI.splice(0,remainingEventToReachLimit));
    }
  } else {
    return sortedEvents;
  }

  remainingEventToReachLimit = limit - sortedEvents.length;
  if(remainingEventToReachLimit > 0) {
    if(spanishEventApproachingCapacityAndDeadline.length <= remainingEventToReachLimit) {
      sortedEvents = sortedEvents.concat(spanishEventApproachingCapacityAndDeadline);
    } else {
      sortedEvents = sortedEvents.concat(spanishEventApproachingCapacityAndDeadline.splice(0,remainingEventToReachLimit));
    }
  } else {
    return sortedEvents;
  }

  remainingEventToReachLimit = limit - sortedEvents.length;
  if(remainingEventToReachLimit > 0) {
    if(englishEventApproachingCapacityAndDeadlineTOI.length <= remainingEventToReachLimit) {
      sortedEvents = sortedEvents.concat(englishEventApproachingCapacityAndDeadlineTOI);
    } else {
      sortedEvents = sortedEvents.concat(englishEventApproachingCapacityAndDeadlineTOI.splice(0,remainingEventToReachLimit));
    }
  } else {
    return sortedEvents;
  }

  remainingEventToReachLimit = limit - sortedEvents.length;
  if(remainingEventToReachLimit > 0) {
    if(spanishWLTOI.length <= remainingEventToReachLimit) {
      sortedEvents = sortedEvents.concat(spanishWLTOI);
    } else {
      sortedEvents = sortedEvents.concat(spanishWLTOI.splice(0,remainingEventToReachLimit));
    }
  } else {
    return sortedEvents;
  }

  remainingEventToReachLimit = limit - sortedEvents.length;
  if(remainingEventToReachLimit > 0) {
    if(spanishWL.length <= remainingEventToReachLimit) {
      sortedEvents = sortedEvents.concat(spanishWL);
    } else {
      sortedEvents = sortedEvents.concat(spanishWL.splice(0,remainingEventToReachLimit));
    }
  } else {
    return sortedEvents;
  }

  remainingEventToReachLimit = limit - sortedEvents.length;
  if(remainingEventToReachLimit > 0) {
    if(englishWLTOI.length <= remainingEventToReachLimit) {
      sortedEvents = sortedEvents.concat(englishWLTOI);
    } else {
      sortedEvents = sortedEvents.concat(englishWLTOI.splice(0,remainingEventToReachLimit));
    }
  } else {
    return sortedEvents;
  }
  
  return sortedEvents;
}

const filterCategories = (collections, filters) => {
  let filteredCollections = [];
  let startDateFilter = filters.dates?.startDate ? new Date(filters.dates.startDate) : null;
  let endDateFilter = filters.dates?.endDate ? new Date(filters.dates.endDate) : null;

  collections.forEach(collection => {
    //Topics Filter
    let taggedTopics=collection?.tags?.map(t=>t.toLowerCase());
    if(filters?.selectedTopicsOfInterest?.indexOf("View all") == -1 && filters?.selectedTopicsOfInterest?.length > 0 && !filters?.selectedTopicsOfInterest?.some(r=> taggedTopics?.includes(r.toLowerCase()))) {
      return;
    }

    //date filter
    const collectionStart = new Date(collection?.startDate);
    const collectionEnd = new Date(collection?.endDate);

    if(startDateFilter && endDateFilter) {
      if ((startDateFilter && collectionEnd < startDateFilter) || (endDateFilter && collectionStart > endDateFilter)) {
        return;
      }
    }

    //Status Filter
    if(filters.statuses?.length > 0) {
      if(collection.format == "Event") {
        let keepThisEvent = false;
        if(filters.statuses.indexOf("availableSeats") != -1 && (collection.availableSeats > 0 || collection.seatLimit == 0)) {
          keepThisEvent = true;
        } 
        if(filters.statuses.indexOf("waitingAvailable") != -1 && collection.availableSeats <= 0 && !keepThisEvent) {
          keepThisEvent = true;
        } 
        if(filters.statuses.indexOf(collection.enrollmentStatus) != -1 && !keepThisEvent) {
          keepThisEvent = true;
        }
        if(filters.statuses.indexOf("RECORDED_EVENTS") != -1 && collection.isRecordedEvent && !keepThisEvent) {
          keepThisEvent = true;
        }
        if(filters.statuses.indexOf('View all') != -1) {
          keepThisEvent = true;
        }
        if(!keepThisEvent)
          return;
      } else {
      if(filters.statuses.indexOf(collection.enrollmentStatus) == -1 && filters.statuses.indexOf('View all') == -1) {
        return;
      }
    }
    }

    //Type check
    if(filters.type.length > 0) {
      if(collection.format == "Quick Tip") {
        if(filters.type.indexOf(collection.resourceType) == -1 && filters.type.indexOf('View all') == -1)
          return;
      } else if (!filters.type.some(r=> collection.tags?.includes(r)) && filters.type.indexOf('View all') == -1){
        return;
      }
    }
    
    //Format Check
    if(filters.format?.length > 0) {
      if(filters.format.indexOf(collection.format) == -1) {
          return;
      }
    }

    //Skill Level
    if(filters.skillLevel?.length > 0 && filters.skillLevel?.indexOf('View all') == -1 && !filters.skillLevel?.some(r=> collection.skillLevels?.includes(r)))
    return;

    //Langauage Filter
    if(filters.language?.length > 0 && filters.language?.indexOf('View all') == -1 && !filters.language.some(r=> collection.locale?.includes(r)))
      return;

     //Host Filter
     if(filters.host?.length > 0 && filters.host?.indexOf('View all') == -1 && !filters.host.includes(collection?.hostType?.toLowerCase()))
      return;

    filteredCollections.push(collection);
  });  
  
  return filteredCollections;
}

const createFilterInputForUtil = (filterData, page) => {
  let filterInputForUtil = {
    selectedTopicsOfInterest: [],
    dates: {},
    statuses: [],
    type: [],
    format: [],
    language: [],
    skillLevel: [],
    host:[],
    location: "",
  }
  filterData.forEach((filter) => {
    switch(filter.category){
      case "Topic":
        filter?.subCategory?.forEach((item) => {
          item.options.forEach((internalItem) => {
            if(internalItem.selected) {
              filterInputForUtil.selectedTopicsOfInterest.push(internalItem.value);
            }
          });
        });
        break;
      case "Dates":
        if(filter.startDate)
          filterInputForUtil.dates.startDate = filter.startDate;
        if(filter.endDate)
          filterInputForUtil.dates.endDate = filter.endDate;
        break;
      case "Status":
        filter?.subCategory?.forEach((subcat) => {
          subcat.options.forEach((item) => {
            if(item.selected || subcat.options[0].selected) {
              filterInputForUtil.statuses.push(item.value);
            }
          });
        });
        break;
      case "Type":
        if(page == 'myLibrary') {
          filter?.subCategory?.forEach((subcat) => {
            subcat.options.forEach((item) => {
              if(item.selected || subcat.options[0].selected) {
                filterInputForUtil.format.push(item.value);
              }
            });
          });
        } else {
        filter?.subCategory?.forEach((subcat) => {
          subcat.options.forEach((item) => {
            if(item.selected || subcat.options[0].selected) {
              filterInputForUtil.type.push(item.value);
            }
          });
        });
        }
        break;
      case "Skill level":        
        // Courses/Events mapped to 'all' should appear regardless of which tick box is selected
        filterInputForUtil.skillLevel.push('All:1');
        filter?.subCategory?.forEach((subcat) => {
          subcat.options.forEach((item) => {
            if(item.selected || subcat.options[0].selected) {
              filterInputForUtil.skillLevel.push(item.value);
            }
          });
        });
        break;
      case "Language":
        filter?.subCategory?.forEach((subcat) => {
          subcat.options.forEach((item) => {
            if(item.selected || subcat.options[0].selected) {
              filterInputForUtil.language.push(item.value);
            }
          });
        });
        break;
      case "Host":
        filter?.subCategory?.forEach((subcat) => {
          subcat.options.forEach((item) => {
            if (item.selected || subcat.options[0].selected) {
              filterInputForUtil.host.push(item.value);
            }
          });
        });
        break;
      case "Location":
        if(filter.locationSelected){
          filterInputForUtil.location = filter?.locationSelected;
        break;
        }
    }
  });
  return filterInputForUtil;
}


const createInputForGASearchFilter = (filterData, page) => {
  let filterInputForUtil = {
    selectedTopicsOfInterest: [],
    dates: {},
    statuses: [],
    type: [],
    format: [],
    language: [],
    skillLevel: []
  }
  filterData.forEach((filter) => {
    switch(filter.category){
      case "Topic":
        filter?.subCategory?.forEach((item) => {
          item?.options?.forEach((internalItem) => {
            if(internalItem?.selected) {
              filterInputForUtil.selectedTopicsOfInterest.push(internalItem?.children);
            }
          });
        });
        break;
      case "Dates":
        if(filter.startDate)
          filterInputForUtil.dates.startDate = filter?.startDate;
        if(filter.endDate)
          filterInputForUtil.dates.endDate = filter?.endDate;
        break;
      case "Status":
        filter?.subCategory?.forEach((subcat) => {
          subcat?.options?.forEach((item) => {
            if(item?.selected) {
              filterInputForUtil.statuses.push(item?.children);
            }
          });
        });
        break;
      case "Type":
        if(page == 'myLibrary') {
          filter?.subCategory?.forEach((subcat) => {
            subcat?.options?.forEach((item) => {
              if(item?.selected) {
                filterInputForUtil.format.push(item?.children);
              }
            });
          });
        } else {
        filter?.subCategory?.forEach((subcat) => {
          subcat?.options?.forEach((item) => {
            if(item?.selected) {
              filterInputForUtil.type.push(item?.children);
            }
          });
        });
        }
        break;
      case "Skill level":       
        // Courses/Events mapped to 'all' should appear regardless of which tick box is selected
        filterInputForUtil.skillLevel.push('All:1');
        filter?.subCategory?.forEach((subcat) => {
          subcat?.options?.forEach((item) => {
            if(item?.selected) {
              filterInputForUtil.skillLevel.push(item?.children);
            }
          });
        });
        break;
      case "Language":
        filter?.subCategory?.forEach((subcat) => {
          subcat?.options?.forEach((item) => {
            if(item?.selected) {
              typeof item?.children === "object" ? filterInputForUtil.language.push(item?.children?.props?.children?.[1]) : filterInputForUtil.language.push(item?.children);
            }
          });
        });
        break;
    }
  });
  return filterInputForUtil;
}

const relatedResourcesCards = (courseId, MAX_NUMBER_OF_TILES, allCourses, allEventsWithTimeZone, allQuickTips, Lp) => {
  const userLanguage = localStorage.getItem("lng") ? localStorage.getItem("lng") : 'en';
  moment.locale(userLanguage);

  let events = allEventsWithTimeZone?.filter(e => new Date(e.startDate).getTime() >= new Date().getTime()) || [];
  let courses = allCourses || [];
  let tips = allQuickTips || [];

  if (courseId) {
    courses = courses.filter(e => e.id !== courseId);
    events = events.filter(e => e.id !== courseId);
    tips = tips.filter(e => e.id !== courseId);
  }

  let courseDetailssecondaryListTemp = [];
  switch (userLanguage) {
    case "en":
      events = events.filter(e => e.locale?.indexOf('en-US') !== -1);
      courses = courses.filter(e => e.locale?.indexOf('en-US') !== -1);
      tips = tips.filter(e => e.locale?.indexOf('en-US') !== -1);

      while (courseDetailssecondaryListTemp.length < MAX_NUMBER_OF_TILES &&
        (courses.length > 0 || events.length > 0 || tips.length > 0)) {
        if (courses.length > 0) {
          courseDetailssecondaryListTemp.push(courses.shift());
        }
        if (events.length > 0) {
          courseDetailssecondaryListTemp.push(events.shift());
        }
        if (tips.length > 0) {
          courseDetailssecondaryListTemp.push(tips.shift());
        }
      }
      break;

    case "es":
      let spanishEvents = [];
      let bilingualEvents = [];
      let englishEvents = [];

      events?.forEach((event) => {
        if (event.locale.indexOf('en-US') !== -1 && event.locale.indexOf('es-ES') !== -1) {
          bilingualEvents.push(event);
        } else if (event.locale.indexOf('es-ES') !== -1) {
          spanishEvents.push(event);
        } else {
          englishEvents.push(event);
        }
      });

      let spanishCourses = [];
      let bilingualCourses = [];
      let englishCourses = [];

      courses?.forEach((course) => {
        if (course.locale.indexOf('es-ES') !== -1) {
          spanishCourses.push(course);
        } else {
          englishCourses.push(course);
        }
      });

      let spanishTips = [];
      let bilingualTips = [];
      let englishTips = [];

      tips?.forEach((tip) => {
        if (tip.locale.indexOf('es-ES') !== -1) {
          spanishTips.push(tip);
        } else {
          englishTips.push(tip);
        }
      });

      events = spanishEvents.concat(bilingualEvents).concat(englishEvents);
      courses = spanishCourses.concat(bilingualCourses).concat(englishCourses);
      tips = spanishTips.concat(bilingualTips).concat(englishTips);

      let index = 0;
      while (courseDetailssecondaryListTemp.length < MAX_NUMBER_OF_TILES &&
        (courses.length > 0 || events.length > 0 || tips.length > 0)) {
        if (index % 3 === 0 && courses.length > 0) {
          courseDetailssecondaryListTemp.push(courses.shift());
        } else if (index % 3 === 1 && events.length > 0) {
          courseDetailssecondaryListTemp.push(events.shift());
        } else if (index % 3 === 2 && tips.length > 0) {
          courseDetailssecondaryListTemp.push(tips.shift());
        }
        index++;
      }
      break;
  }
  return courseDetailssecondaryListTemp;
}

const mapperForCourseCardDesktop = (collection) => {
  switch (collection.format) {
    case "Event":
      if(!collection?.isInPersonEvent && collection.additionalStatus && Object.keys(collection.additionalStatus).length > 0) {
        return ({
          desktopImage: collection.image,
          lmsImage: collection?.lmsImage,
          label: collection.title,
          duration: { 
            time: collection.additionalStatus.tagName, 
            color: collection.additionalStatus.color, 
            icon: collection.additionalStatus.tagIcon, 
            preTextIcon: collection.additionalStatus.registeredIcon,
            preText: collection.duration.tileViewTime
          },
          resourceType: collection.type,
          format: collection.format,
          tag:collection.tag,
          showBookmarkIcon: false,
          courseId: collection.id,
          startDate: collection.startDate,
          endDate: collection.endDate,
        });
      } else if(collection?.isInPersonEvent){
        return ({
          additionalStatus: collection?.additionalStatus,
          desktopImage: collection.image,
          lmsImage: collection?.lmsImage,
          label: collection.title,
          duration: { 
            time: collection.duration.dateTime, 
            color: "#716F6D", 
            icon: 'calendar' 
          },
          resourceType: collection.type,
          format: collection.format,
          tag:collection.tag,
          showBookmarkIcon: false,
          courseId: collection.id,
          city: collection?.eventCity,
          timeZone: collection?.eventTimeZone,
          cardDate: collection?.cardDate,
          metroArea: collection?.eventMetroArea,
          isFinalDayEnrollment: collection?.isFinalDayEnrollment
        });
      } else if(collection.isRecordedEvent){
        return ({
          desktopImage: collection.image,
          lmsImage: collection?.lmsImage,
          label: collection.title,
          duration: { 
            time: collection.completedDuration ? collection.completedDuration: collection.duration, 
            color: collection.timeColor? collection.timeColor: DEFAULT_COLOR, 
            icon: collection.icon 
          },
          resourceType: collection.type,
          format: collection.format,
          tag:collection.tag,
          showBookmarkIcon: false,
          courseId: collection.id,
          isViewed: collection.isViewed ?? '',
          isBookMarked: collection?.isBookMarked ?? ''
        });
      }
      else {
        return ({
          desktopImage: collection.image,
          lmsImage: collection?.lmsImage,
          label: collection.title,
          duration: { 
            time: collection.duration.dateTime, 
            color: collection.duration.color, 
            icon: 'calendar' 
          },
          resourceType: collection.type,
          format: collection.format,
          tag:collection.tag,
          showBookmarkIcon: false,
          courseId: collection.id
        });
      }
    case "Course":
      return ({
        desktopImage: collection.image,
        lmsImage: collection?.lmsImage,
        label: collection.title,
        duration: { 
          time: collection.completedDuration ? collection.completedDuration: collection.duration, 
          color: collection.timeColor? collection.timeColor: DEFAULT_COLOR, 
          icon: collection.icon
        },
        resourceType: collection.type,
        format: collection.format,
        tag:collection.tag,
        showBookmarkIcon: false,
        courseId: collection.id
      });
    case "Quick Tip":
      const userLanguage = localStorage.getItem("lng") ? localStorage.getItem("lng") : 'en';
      let title = collection.label;
      let resourceCategory = collection.resourceType;
      let dateTimeValue = collection.dateAndTimeValue;
      if(userLanguage && userLanguage == 'es') {
        title = collection.labelSpanish ? collection.labelSpanish : collection.label;
        resourceCategory = collection.resourceTypeSpanish ? collection.resourceTypeSpanish : collection.resourceType;
        dateTimeValue = collection.dateAndTimeValueSpanish ? collection.dateAndTimeValueSpanish : collection.dateAndTimeValue;
      }
      let tag="";
      const dateTimeStap = collection.publishedOnDate;
      const currentDate = new Date();
      const dateDiff = (currentDate - new Date(dateTimeStap)) / (1000 * 60 * 60 * 24);

      if(collection.locale.indexOf('es-ES') != -1 && userLanguage === "es"){
        tag= TAG_SPANISH;
      }else if(dateDiff <= 30){
        tag= TAG_JUST_ADDED;
      }
      return ({
        desktopImage: collection.image ?? collection.desktopImage,
        lmsImage: collection?.lmsImage,
        label: title,
        duration: { 
          time: dateTimeValue ? dateTimeValue : collection.dateAndTimeValue, 
          color: DEFAULT_COLOR, 
          icon: 'timer'
        },
        resourceType: resourceCategory,
        format: collection.format,
        tag:tag,
        showBookmarkIcon: false,
        courseId: collection.courseId
      });
  }
}
 const loadQuickTips=(language)=> {
  switch (language) {
    case "en":
      console.log("quickTip_en", quickTip_en);
      return quickTip_en;
    case "es":
      return quickTip_es;
  }
}

const decodeHTML = (htmlString) => {
  const parser = new DOMParser();
  const decodedString = parser.parseFromString(htmlString, 'text/html').body.textContent;
  return decodedString;
};

const mapperForCourseCxCard = (collection, courseCxJsonData) => {
  const {
    eventModuleTxts: {askExpertLabel, hisIcon, realTimeIcon, regClosedTxt,joinEventTxt,spotsRemainingTxt,eventFullTxt,endedTxt,handsOnHelpLabel,startSoonTxt,signalBrodIcon,qandaLabel,minRemLabel,eventText,finalDayTxt,timerIcon,registeredTxt,calenderIcon,networkingLabel,waitlistedTxt,warnIcon},
    courseModuleTxts: {standardCourseLabel,miniCourseLabel,courseText},
    relatedsection:{ qtText,  recAvailable, completedIcon,  inProgressIcon, learningPathTxt, quickTipText, minutestxt,  bilingualtag, spanishtag, justaddedtag, inProgressTxt, getstartedtxt, completedTxt}
  } = courseCxJsonData ?? {};

  const mapTagName = (tagName) => {
    if (tagName.includes('spots') || tagName.includes('remaining')) {
      return `${tagName.split(' ')[0]} ${spotsRemainingTxt}`;
    }
    switch (tagName) {
      case EVENT_FULL_WAITLIST_AVAILABLE_TEXT:
        return eventFullTxt;
      case FINAL_DAY_REGISTER:
        return finalDayTxt;
      case REGISTRATION_CLOSED:
        return regClosedTxt;
      default:
        return tagName;
    }
  };
  const mapResourceType = (resType) => {
    switch (resType) {
      case ASK_THE_EXPERT:
        return askExpertLabel;
      case Hands_ON_HELP:
        return handsOnHelpLabel;
      case COURSES_QA:
        return qandaLabel;
      case NETWORKING_SESSIONS:
        return networkingLabel;
      default:
        return resType;
    }
  };

  const mapTagType = (tagType) => {
    switch (tagType) {
      case TAG_BILINGUAL:
        return bilingualtag;
      case TAG_SPANISH:
        return spanishtag;
      case TAG_JUST_ADDED:
        return justaddedtag;
      default:
        return tagType;
    }
  };

  const mapCxResType = (cxResType) => {
    switch (cxResType) {
      case STD_COURSE:
        return standardCourseLabel;
      case MINI_COURSE:
        return miniCourseLabel;
      default:
        return cxResType;
    }
  };

  switch (collection.format) {
    case "Event":
      if(Object.keys(collection.additionalStatus).length > 0) {
        return ({
          desktopImage: collection.image,
          label: collection.title,
          duration: { 
            time: mapTagName(collection.additionalStatus.tagName), 
            color: collection.additionalStatus.color, 
            icon: collection.additionalStatus.tagIcon == WARN_ICON ? warnIcon : collection.additionalStatus.tagIcon, 
            preTextIcon: collection.additionalStatus.registeredIcon, 
            preText: collection.duration.tileViewTime
          },
          resourceType: mapResourceType(collection.type),
          format: collection.format,
          formatLabel: eventText,
          tag:mapTagType(collection.tag),
          showBookmarkIcon: false,
          courseId: collection.id,
          startDate: collection.startDate,
          endDate: collection.endDate,
        });
      } else if(collection.isRecordedEvent) {
        //Recorded events to match course
        return ({
          desktopImage: collection.image,
          lmsImage: collection?.lmsImage,
          label: collection.title,
          duration: { 
            time: collection.completedDuration ? collection.completedDuration: collection.duration, 
            color: collection.timeColor? collection.timeColor: DEFAULT_COLOR, 
            icon: collection.icon
          },
          resourceType: collection.type,
          format: collection.format,
          tag:collection.tag,
          showBookmarkIcon: false,
          courseId: collection.id,
          isViewed: collection.isViewed ?? '',
          isBookMarked: collection?.isBookMarked ?? ''
        });
      } else {
        return ({
          desktopImage: collection.image,
          label: collection.title,
          duration: { 
            time: collection.duration.dateTime, 
            color: collection.duration.color, 
            icon: 'calendar'
          },
          resourceType: mapResourceType(collection.type),
          format: collection.format,
          formatLabel: eventText,
          tag:mapTagType(collection.tag),
          showBookmarkIcon: false,
          courseId: collection.id
        });
      }
    case "Course":
      return ({
        desktopImage: collection.image,
        label: collection.title,
        duration: { 
          time: collection.completedDuration ? collection.completedDuration: (`${collection.duration.split(' ')[0]} ${minutestxt}`), 
          color: collection.timeColor? collection.timeColor: DEFAULT_COLOR, 
          icon: timerIcon
        },
        resourceType: mapCxResType(collection.type),
        format: collection.format,
        formatLabel: courseText,
        tag:mapTagType(collection.tag),
        showBookmarkIcon: false,
        courseId: collection.id
      });
    case "Learning Path":
      return ({
        desktopImage: collection.desktopImage,
        label: collection.label,
        duration: { 
          time: collection.duration.time == GET_STARTED ? getstartedtxt : collection.duration.time, 
          color: collection.duration.color ? collection.duration.color: DEFAULT_COLOR, 
          icon: timerIcon
        },
        resourceType: mapCxResType(collection.type),
        format: collection.format,
        formatLabel: learningPathTxt,
        tag:mapTagType(collection.tag),
        showBookmarkIcon: false,
        courseId: collection.courseId
      });
    case "Quick Tip":
      const userLanguage = localStorage.getItem("lng") ? localStorage.getItem("lng") : 'en';
      let title = collection.label;
      let resourceCategory = collection.resourceType;
      let dateTimeValue = collection.dateAndTimeValue;
      if(userLanguage && userLanguage == 'es') {
        title = collection.labelSpanish ? collection.labelSpanish : collection.label;
        resourceCategory = collection.resourceTypeSpanish ? collection.resourceTypeSpanish : collection.resourceType;
        dateTimeValue = collection.dateAndTimeValueSpanish ? collection.dateAndTimeValueSpanish : collection.dateAndTimeValue;
      }
      let tag="";
      const dateTimeStap = collection.publishedOnDate;
      const currentDate = new Date();
      const dateDiff = (currentDate - new Date(dateTimeStap)) / (1000 * 60 * 60 * 24);

      if(collection.locale.indexOf('es-ES') != -1 && userLanguage === "es"){
        tag= spanishtag;
      }else if(dateDiff <= 30){
        tag= justaddedtag;
      }
      return ({
        desktopImage: collection.desktopImage,
        label: title,
        duration: { 
          time: dateTimeValue ? dateTimeValue : collection.dateAndTimeValue, 
          color: DEFAULT_COLOR, 
          icon: timerIcon
        },
        resourceType: resourceCategory,
        format: collection.format,
        formatLabel: qtText,
        tag:tag,
        showBookmarkIcon: false,
        courseId: collection.courseId
      });
  }
}

const forcedRankingOffers = (offersData) => {
  const forcedRanking = offersData?.forcedRanking;
  const rawOffers = offersData?.offers;
  var orderedInterests = Object.keys(forcedRanking);
  let sortedresults = [];
  let interestIndex = 0, forcedRankIndex = 0, completedIndex = 0;
  while (completedIndex < orderedInterests?.length) {
    const tempObj = forcedRanking?.[orderedInterests[interestIndex]];
    if (tempObj.length > forcedRankIndex) {
      var offerObject = rawOffers[0]?.[tempObj[forcedRankIndex]];
      if (offerObject && sortedresults.filter((item) => item == offerObject).length == 0) {
        sortedresults.push(offerObject);
      }
    } else if(tempObj?.length >0 ) {
      completedIndex++;
    }
    if (interestIndex < (orderedInterests.length - 1)) {
      interestIndex++;
    }
    else {
      interestIndex = 0;
      forcedRankIndex++;
    }
  }
  return sortedresults;
}

const sortArrayByName = (unSortedArray) => {
  return unSortedArray.sort((a, b) => {
      const nameA = a.label.toUpperCase(); // ignore upper and lowercase
      const nameB = b.label.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
    
      // names must be equal
      return 0;
    });
}

const sortLearningPathList = (learningPaths, userLanguage) => {
  //filter in progress and completed
  let defaultStateLP = learningPaths;

  switch (userLanguage) {
    case "en":
      defaultStateLP = defaultStateLP.sort((a,b) => new Date(b.datePublished) - new Date(a.datePublished));
      break;
    case "es":
      let defaultStateLPSpanish = [];
      let defaultStateLPEnglish = [];
      defaultStateLP.forEach((e) => {
        if(e.locale.indexOf('es-ES') != -1) {
          defaultStateLPSpanish.push(e);
        } else {
          defaultStateLPEnglish.push(e);
        }
      });
      defaultStateLPSpanish = defaultStateLPSpanish.sort((a,b) => new Date(b.datePublished) - new Date(a.datePublished));
      defaultStateLPEnglish = defaultStateLPEnglish.sort((a,b) => new Date(b.datePublished) - new Date(a.datePublished));
      defaultStateLP = defaultStateLPSpanish.concat(defaultStateLPEnglish);
      break;
  }

  return defaultStateLP;
}

function LabelsFormat(str){
  let label=str.toLowerCase()
  return label.charAt(0).toUpperCase() + label.slice(1)
}
const getLanguageBasedHref = () => {
  let languageBasedHref = null;
  let locationHref = location.pathname;
  let currentLang = localStorage.getItem("lng") ? localStorage.getItem("lng")  : "en";
  // if(localStorage.getItem('languageSwitchHref')) {
  //   locationHref = localStorage.getItem('languageSwitchHref');
  //   localStorage.removeItem('languageSwitchHref');
  // }
  
  if(currentLang == "es" && locationHref.indexOf("/es") == -1) {
    languageBasedHref = `/${currentLang}${locationHref}`;
  } else if (currentLang == "en" && locationHref.indexOf("/es") != -1){
    languageBasedHref = locationHref.replace("/es","");
  }
  return languageBasedHref;
}

const navigateUsingLanguage = (url) => {
	let language = location.href.indexOf('/es/') != -1 ? 'es' : 'en';
	switch (language) {
		case "es":
			location.href = `/es${url}`
			break;
		case "en":
			location.href = url;
			break;
	}
}

const addOfferStatus = (offer) => {
  offer.statusIcon= "icon-lock-closed onedicon",
  offer.statusText= offer.registerredeemtxt || "RegisterToRedeem",
  offer.statusColor= "#B95319"
  return offer;
}

function checkCapacity(availableSeats,seatLimit){
      const capacity = seatLimit==0 || availableSeats<=0? 0:(availableSeats/seatLimit)*100;
      return capacity;
}

function replaceDate(text,...args){
  let language = localStorage.getItem("lng") === 'en' ? 'en-US' : localStorage.getItem("lng") === 'es' ? 'es-ES' : 'en-US' ;
    let textString= new String(text);
    const options = {
      weekday: 'short', // 'short' for 'Tue'
      month: 'short',   // 'short' for 'Jul'
      day: 'numeric'    // '2-digit' for '17'
     };
    let hoursText = textString.includes("[hours]");
    let minutesText = textString.includes("[minutes]");
    let timerText = textString.includes("timer");
    let dateText = textString.includes("[date]");

    if(timerText){   
       return textString.replace("[timer]","<strong>"+args[0]+"</strong>")
    }else if(dateText){
        let date= new Date(args[0]).toLocaleDateString(language, options);
        return textString.replace("[date]",date);    
    }else if(hoursText && minutesText){
       let string = textString.replace("[hours]",args[0]);
       return new String(string).replace("[minutes]",args[1])
    }else if(hoursText){
        return textString.replace("[hours]",args[0]);    
    }else{
        return textString.replace("[minutes]",args[1])
    }
  }

  function timer24(startTime,endTime){
    let h = Math.floor(moment.duration(endTime.diff(startTime)).asHours());
    let m = Math.floor(moment.duration(endTime.diff(startTime)).minutes());
    let s= Math.floor(moment.duration(endTime.diff(startTime)).seconds());
    if(h<0){
      return '00:00:00';
    }else{
      return `${h <10 ? `0${h}` : h}:${m < 10 ? `0${m}` : m}:${s < 10 ? `0${s}` : s}`
    }
  }

  function mapperForInProgressTime(hoursLeft, minutesLeft, courseCxJsonData){
      const {widgetMsg} = courseCxJsonData || {} ;
      if(hoursLeft==1 && minutesLeft==1){
           return widgetMsg?.evntProgressHrMin;
          }else if(hoursLeft>1 && minutesLeft==1){
           return widgetMsg?.evntProgressHrsMin;
          }else if(hoursLeft==1 && minutesLeft==0){
            return widgetMsg?.evntProgressHr;
          }else if(hoursLeft>1 && minutesLeft==0){
            return widgetMsg?.evntProgressHrs;
          }else if(hoursLeft>1 && minutesLeft>1){
            return widgetMsg?.evntProgress;
          }else if(hoursLeft==1 && minutesLeft>1){
            return widgetMsg?.evntProgressHrMins;
          }else if(hoursLeft==0 && minutesLeft==1){
            return widgetMsg?.evntProgressMin;
          }else{
            return widgetMsg?.evntProgressMins;
          }  
  }
  
  // commenting forrequirement change
  // const RENDITIONS_MAP = {
  //   categoryCourses:{
  //     desktop: "jcr:content/renditions/cq5dam.thumbnail.308.411.png",
  //     tablet: "jcr:content/renditions/cq5dam.thumbnail.243.188.png",
  //     mobile: "jcr:content/renditions/cq5dam.thumbnail.144.144.png",
  //   },
  //   categoryEvents:{
  //     desktop: "jcr:content/renditions/cq5dam.thumbnail.308.411.png",
  //     tablet: "jcr:content/renditions/cq5dam.thumbnail.243.188.png",
  //     mobile: "jcr:content/renditions/cq5dam.thumbnail.144.144.png",
  //   },
  //   categoryquickTips:{
  //     desktop: "jcr:content/renditions/cq5dam.thumbnail.308.411.png",
  //     tablet: "jcr:content/renditions/cq5dam.thumbnail.243.188.png",
  //     mobile: "jcr:content/renditions/cq5dam.thumbnail.144.144.png",
  //   },
  //   categoryLps:{
  //     desktop: "jcr:content/renditions/cq5dam.thumbnail.1280.720.png",
  //     tablet: "jcr:content/renditions/cq5dam.thumbnail.768.768.png",
  //     mobile: "jcr:content/renditions/cq5dam.thumbnail.330.220.png",
  //   },
  //   courseDetails:{
  //     desktop: "jcr:content/renditions/cq5dam.thumbnail.1280.720.png",
  //     tablet: "jcr:content/renditions/cq5dam.thumbnail.768.768.png",
  //     mobile: "jcr:content/renditions/cq5dam.thumbnail.330.263.png",
  //   },
  //   eventDetails:{
  //     desktop: "jcr:content/renditions/cq5dam.thumbnail.1280.720.png",
  //     tablet: "jcr:content/renditions/cq5dam.thumbnail.768.768.png",
  //     mobile: "jcr:content/renditions/cq5dam.thumbnail.330.263.png",
  //   },
  //   quickTipDetails:{
  //     desktop: "jcr:content/renditions/cq5dam.thumbnail.1280.720.png",
  //     tablet: "jcr:content/renditions/cq5dam.thumbnail.768.768.png",
  //     mobile: "jcr:content/renditions/cq5dam.thumbnail.330.263.png",
  //   },
  //   lpDetails:{
  //     desktop: "jcr:content/renditions/cq5dam.thumbnail.1280.720.png",
  //     tablet: "jcr:content/renditions/cq5dam.thumbnail.768.768.png",
  //     mobile: "jcr:content/renditions/cq5dam.thumbnail.330.263.png",
  //   },
  //   learningPathProgress:{
  //     desktop: "jcr:content/renditions/cq5dam.thumbnail.1280.720.png",
  //     tablet: "jcr:content/renditions/cq5dam.thumbnail.768.768.png",
  //     mobile: "jcr:content/renditions/cq5dam.thumbnail.330.263.png",
  //   }
  // }

// image management method
const isMobilevw = screen.width >= 320 && screen.width < 767 ? true : false;
const isIpadvw = screen.width >= 768 && screen.width < 1023 ? true : false;
const isSmallDesktopvw =  screen.width >= 1024 && screen.width < 1233 ? true : false;
const isLargeDesktopvw =  screen.width >= 1233 ? true : false;
const activeViewport = isMobilevw ? 'mobile' : isIpadvw ? 'tablet' : isSmallDesktopvw ? 'desktop' : 'largeDesktop';

// 1. Define the function
// Cache the landing page data promise per URL so it is fetched only once
// instead of triggering a network request on every image render.
const _landingPageDataCache = {};
function fetchLandingPageData() {
  const lang = localStorage.getItem("lng") || 'en';
  const env = config.aemUrlEnv === "QA1" ? "QA2" : (config.aemUrlEnv === "Pilot" ? "pilot" : config.aemUrlEnv);
  const url = `/content/vsbdr/QA1/${lang}/landingPage.common.json`;

  if (_landingPageDataCache[url]) {
    return _landingPageDataCache[url];
  }

  const data = retrieveJsonData(url)
    .then((jsonData) => {
      // landingpageData=jsonData;
      return jsonData;
    })
    .catch((error) => {
      console.error("Failed to retrieve JSON data:", error);
      // Allow a retry on the next call if the fetch failed.
      delete _landingPageDataCache[url];
    });
  _landingPageDataCache[url] = data;
  return data;
}
const imgDomainurl = localStorage.getItem('cDamDomainPath');
const videoDomainurl =localStorage.getItem('cDamVidDomainPath');
const imgDataString = localStorage.getItem('imgData');
const imgObject = (imgDataString && imgDataString !== 'undefined') ? JSON.parse(imgDataString) : null;

function getViewportData(dataObj, targetKey, viewport) {
  if(activeViewport === 'largeDesktop'){
    return dataObj?.[targetKey]?.[viewport] ?? dataObj?.[targetKey]?.['desktop'] ?? "";
  }
    return dataObj?.[targetKey]?.[viewport] ?? ""; 
}

const generateImgPath = (id, section,category,imgObject,imgDomainurl,videoDomainurl) => {
const lng = localStorage.getItem("lng") ? localStorage.getItem("lng") : 'en';
// const skillTagsDomain ='https://assets.verizon.com/is/content/verizonstage/';

  if (!id) return null;
  const domain = imgDomainurl || ''; 
  const rawParams = (section && imgObject) ? getViewportData(imgObject, section, activeViewport) : '';
  const params = rawParams ? rawParams : ''; 
  if(category === 'skillimg'){
    if (domain && id.includes(domain)) {
      return `${id}${params}`;
    }
  }
  if (domain && id.includes(domain)) {
    return `${id}${params}`;
  }
  if(category && category === 'learningpath' && activeViewport === 'mobile'){
    return `${domain}${id}_mob${params}`;
  }
  if(section === 'evntPreVid' || section === 'crsPreVid'){
       // return `https://assets.verizon.com/is/content/verizonqa/${id}${lng === 'es' ? '_vid_es' : '_vid'}${params}`
    return `${videoDomainurl}${id}${lng === 'es' ? '_vid_es' : '_vid'}${params}`
  }
  console.log('micky new Image Inner:;>',domain,params)
  return `${domain}${id}${params}`;
};


  const getImageToBeRendered = async (section, screenType, category, userLanguage, resourseId, qtImagePath = "",imgFormat,sectionKey) => {
    // commenting forrequirement change
    // const renditionUrls = RENDITIONS_MAP[section]
    // const renditionUrl = renditionUrls?.[screenType] || "";
   const landingpageData = await fetchLandingPageData();
   const imgDomainurl = landingpageData?.cDamDomainPath ?? localStorage.getItem('cDamDomainPath') ;
    const videoDomainurl =landingpageData?.cDamVidDomainPath ?? localStorage.getItem('cDamVidDomainPath');   
    const imgDataString = localStorage.getItem('imgData');
    const imgObject = landingpageData?.imgData ?? (imgDataString && imgDataString !== 'undefined') ? JSON.parse(imgDataString) : null;

    console.log("'micky resourseId,sectionKey,global.config.aemUrlEnv>>>>>>>",resourseId,sectionKey, global.config.aemUrlEnv);
   
    // return "https://assets.verizon.com/is/image/verizonqa/15882893";
    const ext = imgFormat ?? 'png';
    
 if(sectionKey === 'evntPreVid' ||  sectionKey === 'crsPreVid'){
  return generateImgPath(sectionKey === 'evntPreVid' ? qtImagePath : resourseId,sectionKey,category,imgObject,imgDomainurl,videoDomainurl);
 }
   const basePath = global.config.AEM_API_BASE_PATH;
    const envPath = global.config.aemUrlEnv === "Pilot" ? "pilot" : "QA1";
    const categoryPaths = {
      courses: "course_details",
      events: "event_details",
      quickTips: "tips-and-resources",
      learningpath: "learningpath",
      inPersonEvents:"inperson_evt_details",
      skillimg: 'skillimg',
      instructorProfile : 'instructorProfile'
    };
    const categoryPath = categoryPaths[category];
    if (!categoryPath) return "";
    if(category === "skillimg"){
      if(qtImagePath?.includes(imgDomainurl)){
         return generateImgPath(qtImagePath,sectionKey,category,imgObject,imgDomainurl,videoDomainurl);
      }else if(qtImagePath?.includes('/content/dam/vsbdr/')){
         return `${basePath}${qtImagePath}`;
      }
    }

    if(category === "quickTips") {
      if(qtImagePath?.includes(imgDomainurl)){
         return generateImgPath(qtImagePath,sectionKey,category,imgObject,imgDomainurl,videoDomainurl);
      }else if(qtImagePath?.includes('/content/dam/vsbdr/')){
         return `${basePath}${qtImagePath}`;
      }
      // return `${qtImagePath}`;
     
    }
    if(category === "learningpath") {
      // const learninScreenType = section === "categoryLps" ? "desktop" : screenType === "tablet" ? "desktop" : screenType
      // return `${basePath}/content/dam/vsbdr/${envPath}images/${categoryPath}/${learninScreenType}/${resourseId}.${ext}`;
      return generateImgPath(resourseId,sectionKey,category,imgObject,imgDomainurl,videoDomainurl);
    }
     if(sectionKey && resourseId){
      //  return "https://assets.verizon.com/is/image/verizonqa/15882893";
      return generateImgPath(resourseId,sectionKey,"",imgObject,imgDomainurl,videoDomainurl);
    }
    // return `${basePath}/content/dam/vsbdr/${envPath}${categoryPath}/${userLanguage}/preview/images/${resourseId}.${ext}`;
  };
  
  function mapTopicsAndTags(currentCourse, aemData){
    let allTopics=[];
    let allTopicsData=[];
    aemData?.allTopics?.allTopicsData?.map((item)=>{
    allTopicsData.push(item?.value?.toLowerCase().split(' ').join(''));
    allTopics[item?.value?.toLowerCase().split(' ').join('')] =item?.label;
    });
    let gaTopics=[];
    currentCourse?.tags?.filter((tag)=>{
    if(allTopicsData?.includes(tag?.toLowerCase().split(' ').join(''))){
      gaTopics.push(allTopics[tag?.toLowerCase().split(' ').join('')]);
    }}).join(',')   
    let result = gaTopics.length == 0 && aemData?.eventFilters ? undefined : gaTopics.slice(0, 3).join(',')
    return result
  }

  function normalizeToMidnight(date) {
    const normalizedDate = new Date(date);
    normalizedDate.setHours(0, 0, 0, 0);
    return normalizedDate;
  }
    
  function normalizeToEndOfDay(date) {
    const endOfDayDate = new Date(date); 
    endOfDayDate.setHours(23, 59, 59, 999); 
    return endOfDayDate;
  }

function sortQuicktipWithLanguagePriority(forceRanking, courses, targetLanguage) {

  const courseMap = new Map();
  for (const course of courses) {
    courseMap.set(course?.courseId, course);
  }
  const priorityGroup = []; // For courses that contain the Espanish
  const secondaryGroup = []; // For courses that do NOT contain Espanish(EN)

  for (const id of forceRanking) {
    const course = courseMap?.get(id);

    if (course) {
      // Check if the locale array includes the target language
      if (course?.locale && course?.locale?.includes(targetLanguage)) {
        priorityGroup?.push(course);
      } else {
        secondaryGroup?.push(course);
      }
    }
    if (courses[id]) {
      delete courses[id];
    }
  }
  const sortBySpanishFirst = (a, b) => {
    if (a?.locale?.indexOf("es-ES") != -1) {
      return -1;
    } else if (b?.locale?.indexOf("es-ES") != -1) {
      return 1;
    }
    return 0;
  };
  const remainingQuicktips = Object.values(courses)?.sort(sortBySpanishFirst);
  console.log('forceRanking,priorityGroup,secondaryGroup,remainingQuicktips>', forceRanking, priorityGroup, secondaryGroup, remainingQuicktips);
  return [...priorityGroup, ...secondaryGroup, ...remainingQuicktips];
}

function parseSSEChunk(jsonStr) {
  try {
    const parsed = JSON.parse(jsonStr);
    let text = '';
    let isComplete = false;
    let followUpQuestions = [];
    let citations = [];
    let searchResults = [];
    let courseResults = [];
    let followUpQuestionText = '';
    let isOverride = false;
    let isSSEOverride = false;
    let overrideScenario = '';
    let tempFlag = '';
    let hasSourcesMoreThanSix = false;

    // Detect vbggpt follow-up question prompt (not the summary stream)
    if (parsed?.author === 'vbggpt' && !parsed?.modelVersion) {
      const vbggptParts = parsed?.content?.parts;
      if (Array.isArray(vbggptParts)) {
        for (const part of vbggptParts) {
          if (typeof part.text === 'string') {
            followUpQuestionText += part.text;
          }
        }
      }
      followUpQuestionText = followUpQuestionText.trim();
    }
    isOverride = parsed?.actions?.stateDelta?.sbdr_override_active;
    isSSEOverride = parsed?.actions?.stateDelta?.sse_override;
    overrideScenario = parsed?.actions?.stateDelta?.sbdr_override_scenario;
    const parts = parsed?.content?.parts;
    if (Array.isArray(parts)) {
      for (const part of parts) {
        if (typeof part.text === 'string') {
          tempFlag = part?.temp;
          text += part.text;
        }
        if (
          part.functionResponse?.name === 'CTA' &&
          Array.isArray(part.functionResponse?.response?.predicted_user_questions)
        ) {
          followUpQuestions = part.functionResponse.response.predicted_user_questions.map(
            (q) => q.question_text
          );
        }
        // Extract citations from Citation_CTA
        if (
          part.functionResponse?.name === 'CTA' &&
          part.functionResponse?.id === 'Citation_CTA' &&
          Array.isArray(part.functionResponse?.response?.citationList)
        ) {
          citations = part.functionResponse.response.citationList;
          hasSourcesMoreThanSix = part.functionResponse.response.has_more_than_six_courses;
        }
        // Extract course results from search_sbdr_courses function response
        if (
          part.functionResponse?.name === 'search_sbdr_courses' &&
          Array.isArray(part.functionResponse?.response?.results)
        ) {
          courseResults = part.functionResponse.response.results;
        }
      }
    }

    // Extract search results from stateDelta (used for sources)
    const sseSearchResults = parsed?.actions?.stateDelta?.sbdr_search_results;
    if (Array.isArray(sseSearchResults) && sseSearchResults.length > 0) {
      searchResults = sseSearchResults;
    }

    if (parsed?.partial === false && text) {
      isComplete = true;
    }

    return { text, isComplete, followUpQuestions, citations, searchResults, courseResults, followUpQuestionText, isOverride, overrideScenario, tempFlag, hasSourcesMoreThanSix, isSSEOverride };
  } catch {
    return { text: '', isComplete: false, followUpQuestions: [], citations: [], searchResults: [], courseResults: [], followUpQuestionText: '', isOverride, overrideScenario, tempFlag: false, hasSourcesMoreThanSix: false, isSSEOverride };
  }
}


/**
 * Retrieve suggestion data from localStorage with LZString decompression.
 * The suggestion value is stored as a compressed UTF-16 string.
 * Returns the decompressed object or null if not found/expired.
 */
function getSuggestionData() {
    const itemStr = localStorage.getItem('suggestion');
    if (!itemStr) return null;
    try {
        const item = JSON.parse(itemStr);
        if (!item || !item.expiry) return null;
        const now = new Date();
        if (now.getTime() > item.expiry) {
            localStorage.removeItem('suggestion');
            return null;
        }
        // Decompress the value
        const decompressed = LZString.decompressFromUTF16(item.value);
        return decompressed ? JSON.parse(decompressed) : item.value;
    } catch (error) {
        console.error('Error reading suggestion data:', error);
        return null;
    }
}

function resourceTypeMapping(resource, aisearchJsonData=[], currentOrigin = window.location.origin) {
  // 1. Sanitize the launchUrl by stripping out any hardcoded environments
  let cleanLaunchUrl = resource?.launchUrl || resource?.link || '';
  if (cleanLaunchUrl) {
    try {
      // If this parses successfully, it's an absolute URL (e.g., https://pilot-...)
      const parsedUrl = new URL(cleanLaunchUrl);
      console.log('parsedUrl', parsedUrl);
      // Extract just the relative path
      cleanLaunchUrl = parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
       console.log('cleanLaunchUrl', cleanLaunchUrl);
    } catch (e) {
      // If parsing fails, it's already a relative path, so we leave it as is
    }
  }

  // 2. Use `cleanLaunchUrl` for all the subsequent checks instead of `resource.launchUrl`
  if (resource?.type && (resource.type === 'instructor' || resource.type === 'spotlight')) {
    return {
      eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.[resource.type]?.eyebrowText || '',
      imageUrl: `${resource?.imageUrl}` || '',
      title: resource?.title || '',
      redirectUrl: resource.type === 'instructor' ? `/instructor-details/${resource?.id}` : '/community',
    };
  } else if (resource?.id && resource?.format === 'Quick Tip') {
    return {
      eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.['quicktips']?.eyebrowText || '',
      imageUrl: `${resource?.imageUrl}` || '',
      title: resource?.title || '',
      redirectUrl: `${cleanLaunchUrl}${resource?.id}` || '',
    };
  } else if (!resource?.id && typeof cleanLaunchUrl === 'string' && cleanLaunchUrl.includes('/funding')) {
    const fundingEyebrowKey = cleanLaunchUrl.includes('/funding/details') ? 'funding/details' : 'funding';
    return {
      eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.[fundingEyebrowKey]?.eyebrowText || '',
      imageUrl: aisearchJsonData?.['typeaheadCardsMapping']?.[fundingEyebrowKey]?.aiImgUrl || `${resource?.imageUrl}` || '',
      title: resource?.title || '',
      redirectUrl: `/${fundingEyebrowKey}`,
    };
  } else if (!resource?.id && typeof cleanLaunchUrl === 'string' && cleanLaunchUrl.includes('/customerSupport')) {
    const customerSupportSuffix = (cleanLaunchUrl.split('/customerSupport/')[1] || '').split(/[?#]/)[0].replace(/^\/+|\/+$/g, '');
    const customerSupportEyebrowKey = customerSupportSuffix ? `customerSupport/${customerSupportSuffix}` : 'customerSupport';
    return {
      eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.[customerSupportEyebrowKey]?.eyebrowText || '',
      imageUrl: aisearchJsonData?.['typeaheadCardsMapping']?.[customerSupportEyebrowKey]?.aiImgUrl || `${resource?.imageUrl}` || '',
      title: resource?.title || '',
      redirectUrl: `/${customerSupportEyebrowKey}`,
    };
  } else if (!resource?.id && typeof cleanLaunchUrl === 'string' && cleanLaunchUrl.includes('/results/')) {
    const resultsSuffix = (cleanLaunchUrl.split('/results/')[1] || '').split(/[?#]/)[0].replace(/^\/+|\/+$/g, '').toLowerCase();
    const resultsEyebrowKey = resultsSuffix ? `results/${resultsSuffix}` : 'results';
    return {
      eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.['results']?.eyebrowText || '',
      imageUrl: aisearchJsonData?.['typeaheadCardsMapping']?.['results']?.aiImgUrl || `${resource?.imageUrl}` || '',
      title: resource?.title || '',
      redirectUrl: `/${resultsEyebrowKey}`,
    };
  } else if (!resource?.id && typeof cleanLaunchUrl === 'string' && cleanLaunchUrl.includes('/category/')) {
    const categorySuffix = (cleanLaunchUrl.split('/category/')[1] || '').split(/[/?#]/)[0].trim().toLowerCase();
    const categoryEyebrowKey = categorySuffix ? `category${categorySuffix}` : '';
    return {
      eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.[categoryEyebrowKey]?.eyebrowText || aisearchJsonData?.['typeaheadCardsMapping']?.['categoryevents']?.eyebrowText || '',
      imageUrl: aisearchJsonData?.['typeaheadCardsMapping']?.[categoryEyebrowKey]?.aiImgUrl || `${resource?.imageUrl}` || '',
      title: resource?.title || '',
      redirectUrl: `${categorySuffix ? `/category/${categorySuffix}` : ''}`,
    };
  } else if (!resource?.id && typeof cleanLaunchUrl === 'string') {
    const normalizedLaunchUrl = cleanLaunchUrl.trim().replace(/\/+$/, '');
    
    // 3. Rebuild the final URL dynamically with the current environment's origin
    const finalRedirectUrl = currentOrigin + (normalizedLaunchUrl.startsWith('/') ? '' : '/') + normalizedLaunchUrl;

    return {
      eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.['other']?.eyebrowText || '',
      imageUrl: aisearchJsonData?.['typeaheadCardsMapping']?.['other']?.aiImgUrl || `${resource?.imageUrl}` || '',
      title: aisearchJsonData?.['typeaheadCardsMapping']?.['other']?.label || resource?.title || '',
      redirectUrl: finalRedirectUrl,
    };
  }
  return null;
}

function getPromotionByCourseId(courseId, promotionsData) {
  let promotions = Array.isArray(promotionsData) ? promotionsData : [];
  if (!promotions.length) {
    const storedPromotions = localStorage.getItem('promotions');
    if (storedPromotions) {
      try {
        const parsedPromotions = JSON.parse(storedPromotions);
        promotions = Array.isArray(parsedPromotions) ? parsedPromotions : [];
      } catch (e) {
        promotions = [];
      }
    }
  }
  if (!courseId || !promotions.length) {
    return null;
  }
  return promotions.find((promotion) => String(promotion?.id) === String(courseId)) || null;
}

function findCourseById(courseId, cachedData, item, aisearchJsonData) {

  if (!cachedData) {
    console.warn("^^No landing page data found in cache");
    return null;
  }


  for (const property of Object.keys(cachedData)) {
    if (cachedData[property] && typeof cachedData[property] === 'object') {
      // Check if courseId exists as a key in this nested object
      if (cachedData[property].hasOwnProperty(courseId)) {
         console.log(`^^Course ID "${courseId}" found in category "${property}"`);
        return { 'resource': cachedData[property][courseId], 'resourceType': property };
      }
    }
  }

  // Fallback: ids like id_grants map directly to a typeahead card using the suffix key.
  if (typeof courseId === 'string' && courseId.startsWith('id')) {
    // const derivedResourceType = courseId.replace('id_', '');
      console.log(`^^Course ID "${courseId}" not found in any category, but using fallback mapping`);
     let matchedPromotion = null;
      if(item?.type && item?.type === 'page') {
     matchedPromotion = getPromotionByCourseId(courseId);
     console.log(`^^matchedPromotion ID ${courseId}`, matchedPromotion);
    if (matchedPromotion) {
      return { 'resource': matchedPromotion, 'resourceType': 'promotion' };
    }
  }
    return { 'resource': {
      eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.['promotion']?.['eyebrowText'] || "",
      imageUrl:`${item?.type === 'page' ? matchedPromotion?.imgPath : item?.imageUrl}${aisearchJsonData?.['imgqueryparam'] ?? "?wid=68&hei=68&fit=crop,1&resMode=sharp2&op_sharpen=1"
}` || item?.imageUrl || "",
      title:`${ item?.type === 'page' ? matchedPromotion?.title : item?.title}` || "",
      redirectUrl: `/course-details/${courseId}`,
      // iconName: item?.iconName || "",
    }, 'resourceType': 'promotion'
    };
  }

  

  console.warn(`^^Course ID "${courseId}" not found in any category`);
  return null;
}

function dynamicImageUrl (item, fallbackUrl, sourceContext = 'ai_recommended_resources', sectionKey = '') {
  const [imageURL, setImageURL] = useState(null);

  useEffect(() => {
    let isCancelled = false;

    const loadImage = async () => {
      if (!item?.id) return;

      try {
        const userlng = localStorage.getItem('lng') || 'en';

        const getMappedCategory = () => {
          const cat = (item?.category || item?.type || '').toLowerCase();
          if (cat.includes('person')) return "inPersonEvents";
          if (cat.includes('event')) return "events";
          if (cat.includes('course')) return "courses";
          if (cat.includes('tip')) return "quickTips";
          if (cat.includes('path')) return "learningpath";
          if (cat.includes('library')) return "myLibrary";
          if (cat.includes('instructor')) return "instructorProfile";
          if (cat.includes('skill')) return "skillimg";
          
          return "course_details";
        };

        const mappedCategory = getMappedCategory();
        const safeId = String(item.id).split(':').pop();
        const newUrl = await getImageToBeRendered(
          sourceContext, 
          '', 
          mappedCategory, 
          userlng,
          safeId, 
          mappedCategory === 'quickTips' ? fallbackUrl : '', 
          '', 
          sectionKey
        );
        console.log('dynamicImageUrl newUrl:', newUrl, 'mappedCategory:', mappedCategory, 'item.id:', item.id);
        if (!isCancelled && newUrl) {
          const img = new window.Image();
          img.src = newUrl;
          img.onload = () => {
             console.log('2. SUCCESS: Image loaded in background:', newUrl);
            if (!isCancelled) setImageURL(newUrl);
          };
          img.onerror = (err) => {
            console.error('3. ERROR: Browser failed to load the image! Falling back to:', fallbackUrl, 'Error details:', err);
            if (!isCancelled) setImageURL(fallbackUrl ?? '');
          };
        }
      } catch (error) {
        console.error('Fetch catch block hit:', error);
        if (!isCancelled) {
          setImageURL(fallbackUrl ?? '');
        }
      }
    };

    loadImage();

    return () => {
      isCancelled = true;
    };
  }, [item, fallbackUrl, sourceContext]);

  // Return the fetched image, or fallback to the provided URL, or return empty string
  return imageURL || fallbackUrl || ''; 
};

function getCardFormatText (searchType) {
  const eventCxAemJSONData = useSelector((state) => state?.Aem?.eventCxJsonData);
  const courseCxAemJSONData = useSelector((state) => state?.Aem?.courseCxJsonData);
  const inPersonEventCxAemData = useSelector((state) => state?.Aem?.inPersonEventCxData);

  const getFormatText = (item) => {
    if (!item) return '';

    const categoryOrType = searchType == 'recommonded' ? item?.category.toLowerCase() : item?.format?.toLowerCase();
    
     if(searchType === 'recommonded'){
      if(item?.category?.toLowerCase() === 'course'){
        if(item?.topics?.indexOf('Standard Course') != -1) {
          return STD_COURSE;
        } else if (item?.topics?.indexOf('Mini Course') != -1) {
          return MINI_COURSE;
        }else {
          return item?.format;
        }
      } else if(item?.category?.toLowerCase().includes('event') || item?.category?.toLowerCase().includes('virtual event')  ) {
        if(item.topics?.indexOf('Group Session') != -1) {
          return ASK_THE_EXPERT;
        } else if (item.topics?.indexOf('Workshop/Networking') != -1) {
          return Hands_ON_HELP;
        } else if (item.topics?.indexOf('Networking') != -1) {
            return Hands_ON_HELP;
        } else if (item.topics?.indexOf('Office Hours') != -1) {
          return COURSES_QA;
        } else if (item.topics?.indexOf('Community') != -1) {
          return NETWORKING_SESSIONS
        } else {
          return '';
        }
      } else if(item?.category?.toLowerCase().includes('quick tips')){
        return item?.type;
      } else {
        return '';
      }
    } else if(searchType === 'classic'){
       if(item?.type.toLowerCase().includes("course")){
        if(item?.format?.toLowerCase() === 'blended'){
          if(item?.topics?.indexOf('Group Session') != -1) {
            return ASK_THE_EXPERT;
          } else if (item.topics?.indexOf('Workshop/Networking') != -1) {
            return Hands_ON_HELP;
          } else if (item.topics?.indexOf('Networking') != -1) {
            return Hands_ON_HELP;
          } else if (item.topics?.indexOf('Office Hours') != -1) {
            return COURSES_QA;
          } else if (item.topics?.indexOf('Community') != -1) {
            return NETWORKING_SESSIONS
          } else {
            return '';
          }
        } else if(item.format?.toLowerCase() === 'self paced'){
          if(item.topics?.indexOf('Standard Course') != -1) {
            return STD_COURSE;
          } else if (item.topics?.indexOf('Mini Course') != -1) {
            return MINI_COURSE;
          }else {
            return item?.format;
          }
      }
    } else if (item.format?.toLowerCase() == 'quick tip') {
        return item?.type;
    }
  }
    return '';
  };

  return { getFormatText };
};

// Helper to format ISO date to "Jul 14, 2 PM ET" or "Jul 14, 2:30 PM ET".
// On-the-hour times omit the ":00" minutes; the browser's local short time
// zone name (e.g. ET, CT, PT) is appended.
function formatEventDate (dateString) {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    const parts = formatter.formatToParts(date);
    const get = (type) => parts.find((p) => p.type === type)?.value || '';

    const month = get('month');
    const day = get('day');
    const hour = get('hour');
    const minute = get('minute');
    const dayPeriod = (get('dayPeriod') || '').toUpperCase();

    const timePart = minute === '00' ? hour : `${hour}:${minute}`;
    return `${month} ${day}, ${timePart} ${dayPeriod} ET`.trim();
  } catch (error) {
    return dateString; // fallback to raw string if parsing fails
  }
};

export {
  findCourseById,
    TAG_RECORDED_EVENTS,
    sortQuicktipWithLanguagePriority,
    compareCurrentTimeInSeconds,
    getCookieValue,
    setWithExpiry,
    getWithExpiry,
    createEventObject,
    getSuggestedCourses,
    recommendedEvents,
    comingSoonEvents,
    getSuggestedCoursesbyTopic,
    getForceRankedCourses,
    comingSoonEnglishEvents,
    filterCategories,
    createFilterInputForUtil,
    createInputForGASearchFilter,
    createCourseObject,
    relatedResourcesCards,    
    mapperForCourseCardDesktop,
    mapperForCourseCxCard,
    decodeHTML,
    loadQuickTips,
    forcedRankingOffers,
    forcedRankingOffersTopics,
    createLearningPathObject,
    topicsCollection,
    sortArrayByName,
    sortLearningPathList,
    LabelsFormat,
    getLanguageBasedHref,
    navigateUsingLanguage,
    addOfferStatus,
    checkCapacity,
    replaceDate,
    timer24,
    mapperForInProgressTime,
    formatEventTime,
    getImageToBeRendered,
    mapTopicsAndTags,
    createInPersonEventObject,
    getTimeZoneAbbreviation,
    normalizeToMidnight,
    normalizeToEndOfDay,
    parseSSEChunk,
    getSuggestionData,
    resourceTypeMapping,
    dynamicImageUrl,
    getCardFormatText,
    formatEventDate,
    generateImgPath
};
